import common from './common'
import featuresPay from './feature'

const en = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Product/Variants",
        serialNumber: "Serial Number",
        noProductsFound: "No products found",
        searchByProductSku: "Search by product/SKU",
        searchSerialNumbers: "Search serial numbers",
        transactionDetails: "Transaction Details",
        notAvailable: "N/A",
        mainWarehouse: "Main Warehouse"
    },
    new_build_banner: {
        title: 'New version:',
        is_available: 'is now available',
        fallback_title: 'A new version of the app is available',
        desc: 'Refresh to get the latest features and improvements.',
        refreshing: 'Refreshing…',
        refresh_now: 'Refresh Now',
        later: 'Later',
        you_are_on: "you're on"
    },
    short: {
        finance: 'Finance',
        stock: 'Stock'
    },
    onboarding: {
        welcome: 'Welcome!',
        step: {
            product: {
                totalBreakdown: 'Total Breakdown',
                overallFulfilment: 'Overall Fulfilment',
                totalShippedQty: 'Total Shipped Qty',
                totalReceivedQty: 'Total Received Qty',
                totalOrderedQty: 'Total Ordered Qty',
                totalShippedOrdered: 'Total Shipped / Ordered',
                totalReceivedOrdered: 'Total Received / Ordered',
                viewQty: 'View Qty',
                fetchingQty: 'Fetching quantity details...',
                noStockInfo: 'No stock information found',
                title: '65% Achieved',
                description: 'Only 2 steps left to start your great success!',
                Warehouse: "Warehouse",
            },
            stock: {
                title: '95% Almost Done!!',
                description: 'Just one more step to start your great success! Finish it now.'
            }
        },
        business: {
            title: 'Business successfully created!',
            description: 'Great! Your business has been registered'
        },
        product: {
            title: 'Add your first product',
            description: 'Add a product to start recording stock',
            Warehouse: "Warehouse",
        },
        stock: {
            title: 'Try adding stock',
            description: 'Start recording incoming and outgoing stock'
        },
        action: {
            add_business: {
                title: 'Create Business',
                description: 'Want to create a new business? Click here'
            },
            join_business: {
                title: 'Join Business',
                description: 'Have an invitation code? Join here'
            }
        }
    },
    business: {
        title: 'Select a business, create new, or join',
        add_business: {
            title: 'Create new business',
            name: 'Business name',
            name_placeholder: 'Enter name',
            category: 'Business category',
            category_placeholder: 'Select Category',
            button: 'Create Business'
        },
        edit_business: {
            title: 'Edit business'
        },
        join_business: {
            title: 'Join Business',
            input_code: 'Enter the invitation code below:',
            field_placeholder: 'Invitation code',
            confirm_title: 'Join',
            confirm_text: 'You will become part of the team at '
        },
        no_business: 'No business available',
        create_or_join: 'Create or join a business',
        message: {
            saved: 'Business saved successfully!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Negative stock transactions',
            isNegativeTransactionDisabledHint: 'By turning this on, You can prevent transactions that would result in negative stock.',
            negativeStockError: 'Negative stock transactions are disabled'
        }
    },
    profile: {
        edit_profile: {
            title: 'Edit profile',
            name: 'Full Name',
            name_placeholder: 'Enter full name',
            email: 'Email',
            phone_number: 'Phone Number'
        },
        message: {
            required_name: 'Name is required'
        }
    },
    product: {
        Product: 'Product',
        hideZeroStock: 'Hide Zero Stock',
        allVariants: 'All Variants',
        choose_product: 'Choose Product',
        choose_product_empty: 'Select product and enter quantity',
        choose_product_empty_manufacturing: 'Select product and enter manufacturing quantity',
        search: {
            placeholder: 'Search by name/SKU',
            tooltip: 'Open scanner',
            Warehouse: "Warehouse",
        },
        column: {
            image: 'Photo',
            name: 'Name',
            price: 'Price',
            buying_price: 'Cost Price',
            selling_price: 'Selling Price',
            sku: 'SKU',
            stock: 'Stock',
            quantity: 'Quantity',
            latest_stock: 'Remaining',
            product_deleted: 'Product has been deleted',
            info_not_found: 'Information not available',
            expired_date: 'Expiration Date',
            invoice: 'Invoice'
        },
        no_product: 'No Products Available',
        no_product_subtitle: 'Add your first product to start tracking stock, pricing, and sales.',
        create_first_product: 'Create your first product',
        add_product: {
            sku: 'Product Code',
            sku_placeholder: 'Product Code. Example: 12345',
            name: 'Product Name',
            name_placeholder: 'Enter Product Name',
            initial_stock: 'Initial Stock',
            initial_stock_placeholder: 'Enter Initial Stock',
            buying_price: 'Cost Price',
            buying_price_placeholder: 'Enter Cost Price',
            selling_price: 'Selling Price',
            selling_price_placeholder: 'Enter Selling Price',
            category: 'Category',
            category_placeholder: 'Select Category',
            add_selling_price: 'Add Wholesale Price',
            expired_date: 'Expiration Date',
            expired_date_placeholder: 'Select Date',
            description: 'Description',
            description_placeholder: 'Enter Description',
            custom_label: 'Attribute',
            custom_label_placeholder: 'Enter Key',
            add_custom_label: 'Add More Attribute',
            Warehouse: "Warehouse",
        },
        customerLabel: {},
        choose_selling_price: 'Choose Selling Price',
        selling_price: 'Selling Price',
        total_product: 'Total Products',
        total_quantity: 'Total Stock',
        total_buying_price: 'Total Cost Price',
        total_selling_price: 'Total Selling Price',
        message: {
            required_name: 'Product name is required',
            required_sku: 'SKU is required',
            required_category: 'SKU is required',
            required_quantity: 'Initial stock is required',
            invalid_input_qty: 'Invalid stock quantity',
            required_buying_price: 'Cost price is required',
            required_selling_price: 'Selling price is required',
            required_selling_price_name: 'Selling price name is required',
            required_selling_price_price: 'Selling price is required'
        },
        viewMore: 'View More',
        WarehouseDetails: 'Warehouse Details',
        WarehouseName: 'Warehouse Name',
        AddWarehouse: 'Add Warehouse',
        WarehouseQty: 'Warehouse Quantity',
        Warehouse: 'Warehouse',
        Warehouses: 'Warehouses',
        Variants: 'Variants',
        VariantName: 'Variant Name',
        productVariant: 'Product Variants',
        AddVariant: 'Add Variant',
        TranferItem: 'Transfer Items',
        AddUnit: 'New Unit',
        InitialStkWarehouse: 'Initial Stock required to add variants',
        InitialStockinwarehouse: 'Initial Stock in warehouse',
        TotalQuantity: 'Total Quantity:',
        AddNote: 'Add Note (Cost price)',
        AddNotetitle: 'Add Note',
        VariantSuccessMessage: 'Product Variant updated successfully',
        Next: 'Next',
        Submit: 'Submit',
        INACTIVE: 'INACTIVE',
        errorone: 'Oops! The requested quantity for',
        errortwo: "doesn't match the allocated warehouse quantities. Please adjust the quantity or restock.",
        SelectWarehouse: 'Select Warehouse',
        SelectVariant: 'Select Variant',
        Discount: 'Discount',
        DiscountDetails: 'Discount Details',
        FinalPrice: 'Final Price',
        DiscountType: 'Discount Type',
        DiscountPer: 'Discount %',
        DiscountValue: 'Discount Value',
        Discountonprice: 'Discount on price',
        Discountondiscount: 'Discount on discount',
        AdditionalDiscount: 'Additional Discount',
        SellingPrice: 'Selling Price:',
        Save: 'Save',
        weightedAverageCost: 'Weighted Average Cost',
        OnOriginalPrice: 'On Original Price',
        OnDiscountedPrice: 'On Discounted Price',
        columnSelector: {
            title: 'Show Columns',
            columnsButton: 'Columns',
            costPrice: 'Cost Price',
            sellingPrice: 'Selling Price',
            sku: 'SKU',
            warehouse: 'Warehouse',
            categories: 'Categories',
            safetyStock: 'Safety Stock',
            attributes: 'Attributes',
            notes: 'Notes',
            description: 'Description',
            more: 'more',
            attribute: 'Attribute',
            attributesTitle: 'Attributes',
            categoriesTitle: 'Categories',
            skuAliases: 'Sku Aliases'
        }
    },
    note: {
        title: 'Notes',
        add: 'Add Note',
        no_note: 'No notes available'
    },
    settings: {
        category: 'Category',
        language: 'Language',
        switch_business: 'Switch Business',
        currencySelect: 'Currency',
        languageChangeSuccess: 'Currency Updated Successfully',
        languageChangeErrorMessage: 'Something Went Wrong While Updating Currency',
        currencyAdded: 'Currency Added Successfully',
        currencyDelete: 'Currency Deleted Successfully',
        Selectyourpreferredlanguage: "Select your preferred language"


    },
    selectProductStock: 'Select Product',
    category: {
        category_list: {
            title: 'Product Categories'
        },
        add_category: {
            button: 'New Category',
            title: 'Add New Category'
        },
        edit_category: {
            title: 'Edit Category'
        },
        name: 'Category Name',
        name_placeholder: 'Enter Category Name',
        no_category: 'No categories available'
    },
    staff: {
        add: 'Add Staff',
        edit: 'Edit Staff',
        access: {
            stock: 'Stock',
            add_product: 'Add new product',
            edit_product: 'Edit product',
            delete_product: 'Delete product',
            view_capital_price: 'View Cost Price',
            // view_capital_price: 'View Cost Price',
            add_category: 'Add new category',
            edit_category: 'Edit category',
            delete_category: 'Delete category',
            add_supplier: 'Add new vendor',
            edit_supplier: 'Edit vendor',
            delete_supplier: 'Delete vendor',
            add_customer: 'Add new customer',
            edit_customer: 'Edit customer',
            delete_customer: 'Delete customer',
            add_staff: 'Add staff',
            edit_staff: 'Edit staff',
            delete_staff: 'Delete staff',
            change_business_profile: 'Change business profile',
            access_by_product_category: 'Access by Product Category',
            no_category_message: 'You do not have any category added. Please add CategoryList.',
            expenses: 'Expenses',
            view_expenses: 'View Expenses',
            add_expenses: 'Add Expenses',
            edit_expenses: 'Edit Expenses',
            delete_expenses: 'Delete Expenses',
            warehouse: 'Warehouse',
            add_new_warehouse: 'Add New Warehouse',
            edit_warehouse: 'Edit Warehouse',
            delete_warehouse: 'Delete Warehouse',
            transfer_warehouse: 'Transfer Warehouse',
            transfer_warehouse_approval: 'Transfer Warehouse Approval',
            access_by_warehouse: 'Access by Warehouse',
            no_warehouse_message: 'You do not have any warehouse added. Please add WarehouseList.',
            purchase_order: 'Purchase Order',
            purchase_order_creation: 'Purchase Order Creation',
            purchase_order_edit: 'Purchase Order Edit',
            purchase_order_cancel: 'Purchase Order Cancel',
            purchase_order_reopen: 'Purchase Order Reopen',
            purchase_order_receive: 'Purchase Order Receive',
            sales_order: 'Sales Order',
            sales_order_creation: "Sales Order Creation",
            sales_order_edit: 'Sales Order Edit',
            sales_order_cancel: 'Sales Order Cancel',
            sales_order_reopen: 'Sales Order Reopen',
            sales_order_receive: 'Sales Order Shipped',
            purchase_order_approval: 'Purchase Order Approval',
            sales_order_approval: 'Sales Order Approval',
            can_do_available_warehouse: 'Available Warehouse',
            add_batch: "Batch Creation Approval",
            notification: 'Notification',
            staffNotification: 'Enable Notification',
            assignee: "Assignee",
        },
        no_staff: 'No staff available.'
    },
    code: {
        title: 'New Staff Added!',
        subtitle: 'Share the invitation code below to join:',
        valid: 'Code valid for 48 hours only',
        share: 'Share on WhatsApp',
        copied: 'Copied!',
        invalid: 'Invalid code!'
    },
    history: {
        no_history: 'No history.',
        detail: {
            remove: 'Remove History',
            confirm: 'This feature will affect existing stock, history, and reports.'
        },
        no_history_selected: "No history selected",
        select_history_hint: "Click on a history from the list to view their details",
        select_from_left: "Select from the left panel"
    },
    supplier: {
        add: {
            title: 'Add Vendor'
        },
        edit: {
            title: 'Edit Vendor'
        },
        new: 'New vendor',
        no_supplier: 'No vendors available.',
        bank: {
            title: 'Bank Details'
        },
        note: 'Notes',
        form: {
            name: {
                label: 'Vendor Name',
                placeholder: 'Enter Vendor Name',
                placheolder_not_mandatory: 'Enter name',
                error: {
                    required: 'Name cannot be empty'
                }
            },
            contact: {
                label: 'Contact Number',
                placeholder: '91934554432',
                error: {
                    required: 'Contact number cannot be empty',
                    invalid: 'Invalid number. Must include country code'
                }
            },
            bank_name: {
                label: 'Bank Name',
                placeholder: 'Enter Bank Name'
            },
            bank_account_name: {
                label: 'Account Holder Name',
                placeholder: 'Enter Account Holder Name'
            },
            bank_account_number: {
                label: 'Account Number',
                placeholder: 'Enter Account Number'
            },
            note: {
                label: 'Notes',
                placeholder: 'Add Notes'
            },
            openingBalance: {
                addBtn: 'Add Opening Balance',
                label: 'Opening Balance',
                placeholder: 'Enter Opening Balance',
                error: {
                    negative: 'Opening balance cannot be negative'
                }
            }
        },
        choose: 'Choose Vendor'
    },
    customer: {
        add: {
            title: 'Add Customer'
        },
        edit: {
            title: 'Edit Customer'
        },
        new: 'New customer',
        no_customer: 'No customers available.',
        note: 'Notes',
        form: {
            name: {
                label: 'Customer Name',
                placeholder: 'Enter Customer Name',
                placheolder_not_mandatory: 'Enter name',
                error: {
                    required: 'Name cannot be empty'
                }
            },
            contact: {
                label: 'Contact Number',
                placeholder: '91934554432',
                error: {
                    required: 'Contact number cannot be empty',
                    invalid: 'Invalid number. Must include country code'
                }
            },
            address: {
                label: 'Address',
                placeholder: 'Enter Address'
            },
            note: {
                label: 'Notes',
                placeholder: 'Add Notes'
            },
            openingBalance: {
                addBtn: 'Add Opening Balance',
                label: 'Opening Balance',
                placeholder: 'Enter Opening Balance',
                error: {
                    negative: 'Opening balance cannot be negative'
                }
            }
        },
        choose: 'Select Buyer',
        report: {
            view: 'View Buyer Report',
            title: 'Customer Report',
            no_report: 'There are no reports for buyers on the selected date.',
            column: {
                name: 'Name',
                total_transaction: 'Total Transactions',
                total_amount: 'Total Sales',
                total_profit: 'Total Profit'
            }
        }
    },
    confirm_delete: 'Are you sure you want to delete this data?',
    report: {
        title: 'Report'
    },
    accounting: {
        download_pdf_report: 'Download PDF',
        title: 'Accounting',
        view_report: 'View Financial Report',
        dashboard_title: 'Financial Report',
        stats: 'Statistics',
        accounting_report: 'Accounting Report',
        filter: {
            date: {
                placeholder: 'Select Date',
                submit: 'Apply',
                cancel: 'Reset Filter'
            },
            timeframe: {
                day: 'Daily',
                week: 'Weekly',
                month: 'Monthly',
                year: 'Yearly'
            }
        },
        total_sales: 'Total Sales',
        total_purchases: 'Total Purchases',
        total_profit: 'Total Profit',
        total_expenses: 'Total Expenses',
        assets_value: 'Current Asset Value',
        total_cogs: 'Total COGS',
        total_current_cogs_value: 'Total Current COGS Value',
        current_asset_selling_price: 'Current Asset Selling Price',
        total_selling_price: 'Total Selling Price',
        table: {
            date: 'Date',
            sales: 'Sales',
            purchases: 'Purchases',
            profit: 'Profit',
            expenses: 'Expenses',
            cogs: 'COGS'
        },
        no_data: 'No data available.'
    },
    stock_report: {
        title: 'Stock Report',
        view: 'View Stock Report',
        no_report: 'No stock records for the selected date or staff.',
        allStaffPlaceHolder: 'All Staff',
        column: {
            total_product: 'Current Product Types',
            total_product_quantity: 'Total Current Products'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP Feature',
            description:
                'Your trial period for this feature has ended. Support the development of this local app by subscribing.',
            button: 'View Subscription Plans'
        }
    },
    payment: {
        order: {
            title: 'Payment'
        }
    },
    imageUploadMessage: {
        uploadSize: 'The image size must not exceed 5MB!',
        failedMessage: 'Failed to upload the item image, please try again!',
        successUpload: 'The image was uploaded successfully!',
        failedUIError: 'Failed to delete the image, please try again!',
        SuccessErrorImage: 'The image has been successfully deleted!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Product Name',
        categoryLabel: 'Category',
        BuyingPriceLabel: 'Buying Price',
        SellingLabel: 'Selling Price',
        StockLabel: 'Stock'
    },
    historyColumns: {
        Transactionlabel: 'Transaction Type',
        Locallabel: 'Local Time',
        Createdlabel: 'Created By',
        Vendorlabel: 'Vendor Name',
        Buyerlabel: 'Buyer Name',
        SKUlabel: 'SKU',
        Invoicelabel: 'Invoice',
        Productlabel: 'Product Name',
        Categorylabel: 'Category',
        Buyinglabel: 'Buying Price',
        Sellinglabel: 'Selling Price',
        Initiallabel: 'Initial Stock',
        Finallabel: 'Final Stock',
        Stocklabel: 'Stock Change'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Product Name',
        categoryLabel: 'Category',
        buyingPriceLabel: 'Buying Price',
        sellingPriceLabel: 'Selling Price',
        stockInLabel: 'Stock In',
        stockOutLabel: 'Stock Out',
        remainingStockLabel: 'Remaining Stock',
        openStockLabel: 'Opening Stock',
        weightedAverageCostLabel: 'Weighted Average Cost',
        weightedAverageValueLabel: 'Weighted Average Value',
        weightedAverageCost: 'Weighted Average Cost'
    },
    accountingReportColumns: {
        dateRange: 'Date Range',
        reportingPeriod: 'Reporting Period',
        reportGenerate: 'Report Generate',
        warehouse: 'Warehouse',
        labelDate: 'Date',
        labelSales: 'Sales',
        labelPurchases: 'Purchases',
        labelCogs: 'COGS',
        labelProfit: 'Profit',
        labelExpenses: 'Expenses',
        reportOptions: 'Report Columns',
        summaryCards: 'Summary KPI Cards',
        grandTotal: 'Grand Total',
        continued: 'cont.',
        subtotal: 'Subtotal',
        page: 'Page'
    },
    customerReportColumns: {
        labelName: 'Name',
        labelTotalTransaction: 'Total Transaction',
        labelTotalSales: 'Total Sales',
        labelTotalProfit: 'Total Profit'
    },
    scannerDialog: {
        finished: 'Finished',
        reduce: 'Reduce',
        successfull: 'Successfull',
        searching: 'Searching...',
        title: 'Scanner active. Point it to the barcode!'
    },
    historyFilter: {
        SelectBuyer: 'Select Buyer',
        SelectVendor: 'Select Vendor'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stock Low to High',
        StockHightoLow: 'Stock High to Low',
        AlphabetAZ: 'Alphabet A-Z',
        AlphabetZA: 'Alphabet Z-A'
    },
    minimizeTitle: 'Scanner active',
    security_guarantee: {
        title: 'Data Security Guaranteed'
    },
    invoice: {
        invoicePlaceholder: 'Invoice Number',
        invoiceTitle: 'Invoice',
        manageInvoiceAddress: 'Manage Invoice Address',
        selectOrManageAddresses: 'Select, edit or create custom invoice addresses',
        useBusinessProfileAddress: 'Use Business Profile Address',
        noCustomAddressesFound: 'No Custom Addresses Added',
        createCustomAddressDesc: 'Add custom billing or branch addresses to print on your invoices instead of default business profile data.',
        defaultFromBusinessProfile: 'Default From Business Profile',
        editInvoiceAddress: 'Edit Invoice Address',
        createNewInvoiceAddress: 'Create New Invoice Address',
        logoHeaderImage: 'Logo / Header Image',
        deleteInvoiceAddress: 'Delete Invoice Address?',
        deleteAddressConfirmText: 'Are you sure you want to delete this invoice address? This action cannot be undone.'
    },
    ManageInvoiceAddress: 'Manage Invoice Address',
    SelectOrManageAddresses: 'Select, edit or create custom invoice addresses',
    UseBusinessProfileAddress: 'Use Business Profile Address',
    CreateNewAddress: 'Create New Address',
    UpdatingList: 'Updating list...',
    NoCustomAddressesFound: 'No Custom Addresses Added',
    CreateCustomAddressDesc: 'Add custom billing or branch addresses to print on your invoices instead of default business profile data.',
    DefaultFromBusinessProfile: 'Default From Business Profile',
    EditInvoiceAddress: 'Edit Invoice Address',
    CreateNewInvoiceAddress: 'Create New Invoice Address',
    LogoHeaderImage: 'Logo / Header Image',
    UploadingImage: 'Uploading Image...',
    UploadImage: 'Upload Image',
    BusinessName: 'Business Name',
    AddressDetails: 'Address Details',
    PhoneNumber: 'Phone Number',
    EmailAddress: 'Email Address',
    DeleteInvoiceAddress: 'Delete Invoice Address?',
    DeleteAddressConfirmText: 'Are you sure you want to delete this invoice address? This action cannot be undone.',
    stocklowreport: {
        no_stocklowreport_one: 'No items with Safety Stock settings.',
        no_stocklowreport_two: 'Please add Safety Stock quantity.',
        currentStock: 'Current Stock',
        safetyStock: 'Safety Stock',
        pricing: 'Pricing',
        costPrice: 'Cost Price',
        sellingPrice: 'Selling Price',
        productInfo: 'Product Info',
        category: 'Category',
        description: 'Description',
        no_description: 'No description added',
        variants: 'Variants',
        unitsOnHand: 'units on hand',
        minimumThreshold: 'minimum threshold',
        adjust: 'Adjust',
        all: 'All',
        lowStock: 'Low Stock',
        variantsDetails: 'Variants Details',
        qty: 'Qty',
        addSafetyStock: 'Add Safety Stock',
        searchByNameSku: 'Search by name/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Warehouse Safety Stock'
    },
    low_alert_stock: 'Input safety stock quantity',
    lowStockAlertNotify: "You w'll get a notification when the stock drops below the set quantity",
    applyButtonStockAlert: 'Apply',
    cancelButtonStockAlert: 'Cancel',
    searchProductLabel: 'Search products...',
    successfullyAddedSafetyStock: 'Successfully updated Safety Stock',
    safety_Stock: 'Safety Stock',
    safety_stock_placeholder: 'Enter Safety Stock',
    lowStockDetailsInfo: {
        ProductCode: 'Product Code',
        SafetyStock: 'Safety Stock',
        Stock: 'Stock',
        CostPrice: 'Cost Price',
        SellingPrice: 'Selling Price',
        Category: 'Category',
        Description: 'Description',
        ExpirationDate: 'Expiration Date'
    },
    CustomLang: {
        Attribute: 'Attribute',
        AddAttribute: 'Add Attribute',
        EditAttribute: 'Edit Attribute',
        CustomLabePlaceholder: 'Enter Attribute Name',
        CustomLabePlaceholderSelect: 'Select Type',
        AddMoreAttribute: 'Add More Attribute',
        ItemAttribute: 'Item Attribute',
        TableName: 'Name',
        TableType: 'Type',
        TableAction: 'Action',
        TableDelete: 'Delete',
        TableEdit: 'Edit',
        deleteMessage: 'Attribute Deleted Successfully',
        editSuccessMessage: 'Attribute Updated Successfully',
        AddSuccessMessage: 'Attribute Added Successfully',
        AddAtt: 'Add',
        EditAtt: 'Edit',
        SubmitAtt: 'Submitting...'
    },
    Expenses: {
        ExpensesTitle: 'Expenses',
        AddExpenses: 'Add Expenses',
        ExpenseCategory: 'Expense category',
        NoExpenseCategory: 'No expense category',
        AddExpenseCategory: 'Add expense category',
        SelectExpenseCategory: 'Select expense category',
        NoExpenses: 'No Expenses',
        ExpensesSuccess: 'Expenses created successfully',
        ExpensesSuccessEdit: 'Expenses updated successfully',
        ExpensesCategoryName: 'Expenses category name',
        ExpensesSuccessDelete: 'Expenses Deleted successfully',
        AddNEC: 'Add New Expense Category',
        NC: 'New Expense Category',
        EditNEC: "Edit Expense Category"
    },
    Manufacturing: {
        ProducedProduct: "Produced Product",
        QuantityManufactured: "Quantity Manufactured",
        UnitCost: "Unit Cost",
        RawMaterialsTotal: "Raw Materials Total",
        TotalManufacturingCost: "Total Manufacturing Cost",
        NoRawMaterialsConsumed: "No raw materials consumed.",
        CostBreakdown: "Cost Breakdown",
        GeneratedBatch: "Generated Batch",
        StoredBinLocation: "Stored Bin Location",
        NoManufacturingTransactionsFound: "No manufacturing transactions found",
        AddManufacture: 'Add Manufacturing Details',
        Manufacturing: 'Manufacturing',
        RawMaterials: 'Raw',
        AdditonCosts: 'Additional Costs',
        RawMaterial: 'Raw Material',
        AdditonCost: 'Additional Cost',
        TotalCost: 'Total Cost',
        AddRawMaterial: 'Add raw material for',
        AddAdditonCost: 'Add additional cost for',
        AddMore: 'Add more',
        Add: 'Add',
        Update: 'Update',
        Updating: 'Submitting...',
        ProductRequired: 'Product is required',
        QuantityRequired: 'Quantity is required',
        ChargeRequired: 'Charge is required',
        EstimatedCostRequired: 'Estimated Cost is required',
        PurchasePriceRequired: 'Purchase Price is required',
        SelectCharge: 'Select Charge',
        EstimatedCost: 'Estimated Cost',
        SelectProduct: 'Select a Product',
        Quantity: 'Quantity',
        ManufactureDetails: 'Manufacturing Details',
        BuyingPrice: 'Buying Price',
        LabourCharge: 'Labour Charge',
        ElectricityCost: 'Electricity Cost',
        PackagingCharge: 'Packaging Charge',
        LogisticCost: 'Logistic Cost',
        OtherCharges: 'Other Charges',
        Save: 'Save details',
        PurchasePrice: 'Purchase Price',
        Date: 'Date',
        For: 'For',
        PurchaseRate: 'Purchase Rate (Price)',
        Scrolltoloadmore: 'Scroll to load more...',
        Noproductsfound: 'No products found',
        ManufacturingQuantity: 'Manufacturing Quantity',
        ManufactureAddedSuccess: 'Manufacturing Details updated successfully'
    },
    Warehouses: {
        title: 'Warehouse',
        transferOrder: 'Warehouse',
        AddTransferOrder: 'Add Transfer Items',
        NewWarehouse: 'New Warehouse',
        newHead: 'Start managing multiple warehouses!',
        headTwo: 'Seamlessly track and manage your inventory across multiple warehouses',
        EnableWarehouse: 'ENABLE WAREHOUSE',
        EnableWarehouse2: 'Enable Warehouse',
        OrganizationPrimary: "Organization's Primary",
        Edit: 'Edit',
        AreEnableWarehouse: 'Are you sure you want to enable warehouse?',
        Confirm: 'Confirm',
        Cancel: 'Cancel',
        WarehouseCreatedSuccessfully: 'Warehouse created successfully',
        MarkAsOP: "Mark as Organization's Primary",
        MarkAsInAct: 'Mark as Inactive',
        MarkAsAct: 'Mark as active',
        MarkedAsInactive: 'Warehouse marked as inactive successfully',
        MarkedAsActive: 'Warehouse marked as active successfully',
        MarkedAsOP: 'Warehouse marked as active successfully',
        WareDeletedSuccess: 'Warehouse deleted successfully',
        SuccessfullyUpdatedWarehouse: 'Successfully updated warehouse',
        SuccessfullyCreatedWarehouse: 'Successfully created warehouse',
        EditWarehouse: 'Edit Warehouse',
        AddWarehouse: 'Add Warehouse',
        WarehouseNameIsRequired: 'Warehouse Name is required',
        EnterWarehouseName: 'Enter Warehouse name',
        EnterEmail: 'Enter email',
        EnterPhoneNumber: 'Enter phone number',
        Location: 'Location...',
        name: 'Warehouse name',
        email: 'Email',
        phoneNumber: 'Phone number',
        location: 'Location',
        ViewProducts: 'View Products',
        PageTitle: 'Warehouse',
        noWarehouse: "No warehouses match your search",
        ManageBin: "Manage Bin"
    },
    Assets: {
        headerTitle: 'Assets',
        addAssetMessage: "Add assets here. To assign an asset to staff, go to the staff member's profile.",
        addAsset: 'Add Asset',
        editAsset: 'Edit Asset',
        assetCode: 'Asset Code',
        assetName: 'Asset Name',
        assetCategory: 'Asset Category',
        assetType: 'Asset Type',
        serialNumber: 'Serial Number',
        location: 'Location',
        condition: 'Condition',
        selectCondition: 'Select Condition',
        fair: 'Fair',
        good: 'Good',
        excellent: 'Execellent',
        poor: 'Poor',
        notes: 'Notes',
        submit: 'Submit',
        submitting: 'Submitting',
        noCategory: 'No category',
        selectCategory: 'Select category',
        addAssetCat: 'Add Asset Category',
        addAssetCatName: 'Asset category name',
        edit: 'Edit',
        status: 'Status',
        createdAt: 'Created At',
        viewAsset: 'View Asset',
        assignAsset: 'Assign Asset',
        conditionRet: 'Conditon (On return)',
        searchSelectAssets: 'Search/Select Asset',
        assetAssigned: 'Asset assigned successfully',
        assetReturned: 'Asset returned successfully',
        selectAnAsset: 'Please select an asset',
        action: 'Action',
        noAssetAssigned: 'No assets assigned',
        reAssigned: 'Re-assign',
        assignedAssetsList: 'Assigned Assets List',
        viewHistory: 'View History',
        history: 'Asset History',
        loadingHistory: 'Loading history...',
        loadingMore: 'Loading more...',
        dateTime: 'Date & Time',
        staff: 'Staff',
        AssignedBy: 'Assigned By',
        assign: 'ASSIGN',
        return: 'RETURN',
        unknown: 'UNKNOWN',
        noHistory: 'No history available for this asset.',
        enterReturnNote: 'Enter note for return',
        returnNote: 'Return Note',
        enterAssignNote: 'Enter note for assignment',
        assignNote: 'Assign Note',
        AddNAC: "Add New Asset Category",
        EditNAC: "Edit Asset Category",
        others: "Others"
    },
    LedgerTransaction: {
        ledgerDetails: 'Ledger Details',
        productName: 'Product Name',
        totalQty: 'Total Qty',
        date: 'Date',
        receivedAmt: 'Received Amount',
        paid: 'Paid',
        discount: 'Discount',
        balance: 'Balance',
        more: 'more',
        total: 'Total',
        ledgerupdatedsuccessfully: 'Ledger updated successfully',
        ledgeraddedsuccessfully: 'Ledger added successfully',
        viewLedger: 'View Ledger',
        edit: 'Edit',
        create: 'Create',
        Recieved: 'Recieved [stock in]',
        payMode: 'Payment Mode',
        Refno: 'Ref no'
    },
    ExtraField: {
        attachment: 'Attachment',
        acceptOnlyImg: 'Only accept images.',
        addAttribute: 'Add Attribute',
        acceptImgAndDoc: 'Accept images and documents.'
    },
    phoneInvoiceDownload: {
        Variant: "Variant",
        Warehouse: "Warehouse",
        Bin: "Bin",
        Batch: "Batch",
        Attributes: "Attributes"
    },
    ImportExcel: {
        ImportStockfromExcel: "Import Stock from Excel",
        ImportSafetyStockFromExcel: "Import Safety Stock from Excel",
        DragDrop: "Drag & drop your filled Excel file here, or click to browse",
        DT: "Download Template",
        GB: "Go Back",
        Downloading: "Downloading...",
        ChangeFile: "Change File",
        ReadingExcelfile: "Reading Excel file...",
        Processing: "Processing...",
        submitUpdateStock: "Submit & Update Stock",
        submitUpdateSafetyStock: "Update Safety Stock",
        downloadLatestTemplate: "Download Latest Template",
        productsFound: "products found",
        editSafetyStockBelow: "Edit safety stock values below",
        loginRequired: "Login Required"
    },
    stockForm: {
        managePayments: "Manage Payments",
        invoice: "Invoice",
        challan: "Challan",
        recordPayment: "Record Payment",
        recordPaymentNow: "Record payment now",
        recordPaymentDescCustomer: "Enter what the customer paid",
        recordPaymentDescSupplier: "Enter what the supplier paid",
        payableAmount: "Payable Amount",
        paidAmount: "Paid Amount",
        paymentMethod: "Payment Method",
        paymentDate: "Payment Date",
        reference: "Reference",
        billId: "Bill Number",
        importExcel: "Import from Excel",
        noThanks: "No, Thanks",
        checkHistory: "Check Your History",
        wantViewHistory: "Do you want to view your history?",
        enterPayable: 'Enter Payable Amount',
        enterPaid: 'Enter Paid Amount',
        selectPayment: "Select Payment Method",
        attachment: "Attachment",
        note: "Note",
        serial_numbers: "Serial Numbers",
        enter_serials: "Enter Serial Numbers",
        serial: "Serial",
        enter_serial_placeholder: "Enter serial number...",
        added: "added",
        save_serials: "Save Serials",
        no_quantity: "Please enter quantity first"
    },
    HistoryEdit: {
        products: "Products",
        add_product: "Add Product",
        paidAmountInvalidMessage: 'Paid amount cannot be greater than payable amount',
        removingText: "Removing this product will reverse the stock changes made during this transaction.",
        remove: "Remove",
    },
    ExcelProduct: {
        uploadFile: "Upload File",
        dragDrop: "Drag and drop your Excel file, or click to upload.",
        parsingFile: "Parsing file",
        fileSelected: "File selected",
        reviewImportedData: "Review the imported data below. Columns are auto-matched where possible.",
        changeFile: "Change File",
        back: "Back",
        invalidFileType: "Please upload a valid Excel file (.xlsx or .xls)",
        parseExcelError: "Excel parse error:",
        noData: "Uploaded Excel file has no data.",
        failedToRead: "Failed to read the Excel file. Please try again.",
        Nodata: "NO_DATA",
        unableToRead: "Unable to read the file.",
        buyingMustNumber: "Buying Price must be a number",
        sellingMustNumber: "Selling Price must be a number",
        mustBeNumber: "must be a number",
        bulkUploadfailed: "Bulk upload failed",
        importFromExcel: "Import from Excel",
        generating: "Generating...",
        downloadTemplate: "Download Template",
        uploading: "Uploading...",
        done: "Done",
        requiredField: "{field} is required",
        bulkUpload: "Bulk Upload",
        duplicateSku: "Duplicate SKU found",
        uploadedSuccessfully: "All products uploaded successfully!",
        uploadCompleteIssues: "Upload completed with issues",
        uploaded_products: "Uploaded {count} product(s).",
        failed_products: "{count} failed.",
        failed_items: "Failed items:"
    },
    ProductForm: {
        barcodeQuantity: "Enter Barcode Quantity",
        baseUnit: "Base Unit (Primary)",
        addSecondaryUnit: "Add Secondary Unit?",
        selectUnit: "Select Unit",
        subUnitDetails: "Sub Unit Details",
        subUnit: "Sub Unit",
        selectSubUnit: "Select Sub Unit",
        conversionRate: "Conversion Rate",
        exampleLogic: "Example logic:",
        example: "If you are selling pens in boxes, set the Base Unit as Box and add a Sub Unit pcs with a conversion of 50. This means 1 Box contains 50 pieces.",
        basePrice: "Base Price",
    },
    barcode: {
        settings: 'Barcode Settings',
        labelSize: 'Label size',
        customSize: 'Custom size...',
        widthMm: 'Width (mm)',
        heightMm: 'Height (mm)',
        showPrice: 'Show selling price on label',
        noPrices: 'No selling prices configured for this product.',
        preview: 'Preview',
        generate: 'Generate',
        label: 'label',
        singlePage: 'Single Page',
        downloadOptions: 'Download Options',
        chooseLayout: 'Choose layout for barcodes',
        allInSinglePage: 'Add all barcodes in single page.',
        allInA4Grid: 'All in Single Page',
        allInA4GridSub: 'Lays out all barcodes in an A4 grid',
        onePerPage: 'One Per Page',
        onePerPageSub: 'Each barcode on its own label page'
    },
    Discount: {
        overallDiscount: "Overall Discount",
        final: 'Final',
        balanceDue: "Balance Due",
        tax: "Tax",
    },
    TransferItem: {
        transferItem: 'Transfer Items',
        Date: 'Date',
        Reason: 'Reason',
        enterReason: "Enter Reason",
        Name: 'Name',
        QuantityTransfered: 'Quantity Transfered',
        SWarehouse: 'Source Warehouse',
        SelectSWarehouse: 'Select Source Warehouse',
        DWarehouse: 'Destination Warehouse',
        SelectDWarehouse: 'Select Destination Warehouse',
        CreatedBy: 'Created By',
        CreatedTime: 'Created Time',
        UpdatedTime: 'Updated Time',
        NoOrderFound: 'No Orders Found',
        New: 'New',
        WarehouseItemTransfer: 'Warehouse Items Transfer',
        TotalTransfers: "Total Transfers",
        EnterReason: 'Enter Reason',
        ItemDetails: 'Item Details',
        CurrentAvailable: 'Current Availability',
        TransferQty: 'Transfer Quantity',
        SStock: 'Source Stock',
        DStock: 'Destination Stock',
        addDescription: "Add a description to your item",
        selectVariant: "Select a variant",
        addNewRow: "Add new row",
        typeOrSelectItem: "Type to search",
        scrollToLoadMore: "Scroll to load more",
        noProductsFound: "No products found",
        selectWarehouse: "Select a warehouse",
        note: "Note",
    },
    Sku: {
        searchSelectProduct: "Search/Select Product",
        searchSelectSku: "Search/Select Sku",
        noSkuFound: "No sku found"
    },
    HistoryPage: {
        addFilter: "Add Filter",
        filtersActive: "All filters are active",
        noProducts: "No products",
        download: "Download",
        recentlyUpdated: "Recently Updated",
    },
    StockPage: {
        challanNumber: "Challan Number",
        subTotal: "Sub Total",
        totalTaxes: "Totals & Taxes",
        taxInclusive: "Tax Inclusive",
        discountedValue: "Discounted Value",
        taxValue: "Tax Value",
        totalAmount: "Total Amount",
        close: "Close",
        addTax: "Add Tax",
        label: "Label",
        enterLabel: "Enter Label",
        taxRate: "Tax Rate",
        enterTaxRate: "Enter tax rate",
        selectTaxRate: "Select tax Rate",
        addNewTax: "Add new tax rate",
        discountProducts: "Discounted Value (Products)",
        taxProducts: "Tax Value (Products)",
        clickAddPayment: "Click to add payment",
        paidGreaterPayable: "Paid amount cannot be greater than payable amount",
        vendorCompulsory: 'Vendor is required to record payment',
        customerCompulsory: 'Customer is required to record payment',
        updateInvoiceFormat: "Update Invoice Format",
        updateChallanFormat: "Update Challan Format",
        addPrefix: "Add Prefix",
        prefix: "Prefix"
    },
    EditHistoryPage: {
        search_by_notes: "Search by Notes",
        alertMessage: "This change has been recorded in the history only and does not affect the current product stock.",
        paymentDetails: "Payment Details",
        units: "Units",
        customLabels: "Custom Labels",
        value: "Value",
        Order_Info: "Order Info",
        percentage: "Percentage",
        Stock_updates_on_submit: "Stock updates on submit",
        Summary: "Summary"
    },
    historyCard: {
        paid: "PAID",
        partiallyPaid: "PARTIALLY PAID",
        billDate: "Bill Date",
        productDetails: "Product Details",
        paymentsHistory: "Payments History",
        updatePayment: "Update Payment",
        discounts: "Discounts",
        inclusive: "(inc.)",
        discountOverall: "Discounted Value (Overall)",
        dueAmount: "Due Amount",
        enterPaid: "Enter Paid Amount",
        enterReference: "Enter Reference",
        enterNote: "Enter Note",
        enterInvoice: "Enter Invoice",
        enterChallan: "Enter Challan",
        edit: "Edited"
    },
    printInvoice: {
        billTo: "Bill To",
        ref: "Ref No.",
        mode: "Mode",
        date: "Date",
        amount: "Amount",
        totalPaid: "Total Paid",
        noImage: "No Image"
    },
    Contact: {
        supplier_required: "Supplier is required for stock in",
        customer_required: "customer is required for stock out",
        key: "Key",
        editHistory: "Edit History",
        loading: "Loading..."
    },
    AW: {
        availablewarehouse: "Available Warehouse",
        visibilityManagement: 'Visibility Management',
        availablewarehouses: "Available Warehouses",
        Active: "Active",
        LWarehouse: "Loading Warehouses...",
        NWForthisProduct: "No warehouses found for this product.",
        of: "of",
        WarehouseAvailabilty: "Warehouse Availabilty",
    },
    Currency: {
        searchCurrency: "Search Currencies...",
        addCurrency: "Add Currency",
        addNewCurrency: "Add New Currency",
        editCurrency: "Edit Currency",
        currencySymbol: "Currency Symbol",
        currencyName: "Currency Name",
        enterCurrencySymbol: "Enter Currency Symbol",
        enterCurrencyName: "Enter Currency Name"
    },
    NewReportLang: {
        DM: "Daily Movement",
        WR: "Warehouse Report",
        PDM: "Product Daily Movement",
        TBP: "Total Buying Price",
        TPQ: "Total Product Quantity",
        TP: "Total Products",
        CS: "Current Stock",
        IV: "Inventory Value",
        DA: "Daily Average",
        TSI: "Total Stock In",
        TSO: "Total Stock Out",
        TOR: "Turnover Rate",
        Tv: "Total Value",
        AST: "Active SKU Tracking",
        UT: "Units Tracked",
        SL: "Stock Level",
        Value: "Value",
        IO: "IN/OUT",
        T: "Turnover",
        unitsD: "Units/Day",
        Receivables: "Receivables",
        Sort: "Sort",
        Sort_by: "Sort by",
        Units_available: "Units Available",
        Units_unavailable: "Units Unavailable",
        Current_assets: "Current Assets",
        Search: "Search",

        available: "Available",
        assigned: "Assigned",

        AYSWD: "Are you sure you want to delete?",
        PTS: "Product transfered successfully",

        AUS: "Assets updated successfully",
        ACS: "Assets created successfully",
        VSP: "View selling price",
        HUS: "History updated successfully",
        ICS: "Inventory count created successfully",
        IUS: "Inventory count updated successfully",
    },
    ReplacementReturn: {
        selectProduct: "Please select a product",
        selectReplacementProduct: 'Select at least one replacement product',
        validQuantity: 'Please enter a valid return quantity',
        replacedSuccessfully: "Product replaced successfully",
        returnSuccessfully: "Product returned successfully",
        failedProcess: "Failed to process. Please try again.",
        return: "Return",
        replace: "Replace",
        typeSelectProduct: "Type or select product...",
        returnQuantity: "Return Quantity",
        enterQuantity: "Enter Quantity",
        replacementDate: "Replacement Date",
        returnDate: "Return Date",
        chooseCustomer: "Choose Customer",
        additionalNotes: "Add any additional notes...",
        replacementProducts: "Replacement Products",
        addProducts: "Add More Products",
        tapSelect: "Tap to select from available products",
        currently: "Currently",
        item: "item",
        items: "items",
        selected: "selected",
        selectedItems: "Selected items",
        hideDetails: 'Hide more details',
        showDetails: 'Show more details',
        product: "product",
        priceLevel: "Select price level",
        customPrice: "Enter custom price",
        noReplaceHistory: "No replacement history found",
        replaceReturn: "Replace and Return",
        replaceReturnHistory: "Replacement & Return History"
    },
    OtherComponent: {
        mfgHistoryTitle: "Manufacturing History",
        mfgHistoryDesc: "Track manufactured stock products",
        dailyOperation: "Daily Operations",
        freqUsed: "Frequently used actions to update records quickly",
        manageCategory: "Manage Categories",
        organizeCaterory: "Organize and manage product, expense and asset categories",
        businessRecord: "Business Records",
        organizeRecord: "Organize and manage your business records",
        trackHistory: "Track History",
        completeTracking: "Complete history for auditing and tracking",
        Verifyinventorycount: "Verify inventory count",
        Exchangerates: "Exchange rates",
        Productiontracking: "Production tracking",
        Fixedassetregister: "Fixed asset register",
        Storagelocations: "Storage locations",
        warehouseAvailability: 'Warehouse-level product availability',
        Logreviewspend: "Log & review spend",
        Productgroupings: "Product groupings",
        Classifyexpenditures: "Classify expenditures",
        Assetclassification: "Asset classification",
        Manageexchanges: "Manage exchanges",
        Returnauditlog: "Return audit log",
        Interlocationmoves: "Inter-location moves",
        Manageoperationscategoriesrecordsandhistory: "Manage operations, categories, records and history"
    },
    no_permission_dialog: {
        title: 'No Permission',
        historyDescription: "You don’t have permission to view Transaction History. Please contact your administrator.",
        replacementHistoryDescription: "You don’t have permission to view Replacement & Return History. Please contact your administrator.",
        transferHistoryDescription: "You don’t have permission to view Transfer Warehouse History. Please contact your administrator."
    },
    OthersHistory: {
        title: "Manage History",
        transferHistory: "Manage Transfer History",
        transactionHistory: "Manage Transaction History",
        replacementHistory: "Manage Replacement and Return History"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Browse and purchase products shared by the business.",
        description: "Browse products shared by the business.",
        productsAvailable: "Products Available",
        noImageAvailable: "No Image Available",
        productDetails: 'Product Details',
        inStock: "in stock",
        availableVariants: "Available Variants",
        options: "options",
        orders: "Orders",
        catalogOrders: "Catalog Orders",
        totalCatalogOrders: "Total Online Orders",
        convertToSalesOrder: "Convert to Sales Order",
        pending: "Pending",
        converted: "Converted",
        cancelled: "Cancelled",
        totalRevenue: "Total Value",
        date: "Date",
        status: "Status",
        action: "Action",
        searchOrders: "Search customer or phone...",
        noMatchingOrders: "No matching orders found",
        noStatusOrders: "No {status} orders found",
        tryDifferentSearch: "Try searching with a different customer name or phone number.",
        noOrdersWithStatus: "There are currently no orders with {status} status.",
        noOrdersYet: "No Catalog Orders Yet",
        noOrdersDescription: "Orders placed from your online catalog will appear here.",
        guestCustomer: "Guest Customer",
        item: "Item",
        moreItems: "+{count} more",
        viewDetails: "View Details",
        viewSalesOrder: "View Sales Order",
        cancelOrder: "Cancel Order",
        confirmCancelTitle: "Cancel Catalog Order?",
        confirmCancelOrder: "Are you sure you want to cancel this order? This action cannot be undone.",
        keepOrder: "No, Keep Order",
        confirmCancelAction: "Yes, Cancel Order",
        orderNotFound: "Catalog Order Not Found",
        orderNotFoundDescription: "This order could not be found or you may not have permission to view it.",
        backToCatalogOrders: "Back to Catalog Orders",
        placedOn: "Placed on",
        totalItems: "Total Items",
        products: "Products",
        totalAmount: "Total Amount",
        orderedProducts: "Ordered Products",
        items: "items",
        itemDetails: "Item Details",
        quantity: "Qty",
        unitPrice: "Unit Price",
        total: "Total",
        variant: "Variant",
        subtotal: "Subtotal",
        customerInformation: "Customer Information",
        name: "Name",
        phone: "Phone",
        deliveryAddress: "Delivery Address",
        orderNote: "Order Note",
        additionalFields: "Additional Fields",
        fields: "fields"
    },
    stockNew: {
        Npay: "No products added yet",
        emptydesc: "Select a product from your catalog and enter the incoming quantity to record stock.",
        tipText: "Tip: You can also upload a excel file",
        OT: "Order Total",
        Collapse: "Collapse"
    },
    deleteBulk: {
        Bulkoperation: "Bulk operation",
        Applyproducts: "Apply actions to multiple products",
        Bulkupload: "Bulk upload",
        ImportCSVfile: "Import products via Excel or CSV file",
        or: "or",
        Bulkdelete: "Bulk delete",
        Permanentlyallproducts: "Permanently remove all products",
        IrrText: "Bulk delete is irreversible. Export a backup first if needed.",
        SeP: "Selected products",
        sP: "Select product",
        DA: "Delete All",
        DP: "Delete Products",
        sL: "Select all",
        ASDE: "Are you sure you want to delete all products except",
        ASDAllP: "Are you sure you want to delete all products?",
        ASD: "Are you sure you want to delete",
        products: 'products',
        TACBU: "This action cannot be undone.",
        LP: "Loading products...",
        FM: "Fetching more...",
        NPF: "No products found.",
        LMP: "Loading more products...",
        BulkOperation: "Bulk Operation"
    },
    NewVariantModal: {
        Definevariantsassign: "Define variants & assign quantities",
        Nothingallocated: "Nothing allocated",
        Overallocated: "Over-allocated",
        Fullyallocated: "Fully allocated",
        Overby: "Over by",
        Allvariantsneedaname: "All variants need a name.",
        Reducequantities: "Reduce quantities.",
        Overallocatedby: "Over-allocated by",
        Quantitiesmustmatchthetotalavailability: "Quantities must match the total availability.",
        Allocatequantitiesacrosswarehouses: "Allocate quantities across warehouses",
        Notfullydistributed: "Not fully distributed:",
        remaining: "remaining",
        Qty: "Qty",
        Inactive: "Inactive",
        left: "left"
    },
    ProductFormNew: {
        BasicInfo: "Basic Info",
        ProductImage: "Product Image",
        Images: "Images",
        Pricing: "Pricing",
        Everypriceneedsbothalabelandanamount: "Every price needs both a label and an amount",
        AddalabellikeWholesaleorRetailtoidentifythisprice: `Add a label like "Wholesale" or "Retail" to identify this price`,
        AddMultiplePrice: "Add Multiple Price",
        NoPhotosLetAiFind: "No Photos? Let AI find product images",
        AddProductImagesTitle: "Add Product Images",
        ChooseHowToAddPhotos: "Choose how you want to add photos for this product:",
        SearchWithAi: "Search with AI",
        SearchWithAiDesc: "Automatically find & select product images using AI",
        FilesFileExplorer: "Files (File Explorer)",
        FilesFileExplorerDesc: "Choose images directly from your computer",
        AiProductImageFinder: "AI Product Image Finder",
        AiProductImageFinderDesc: "Search & select images for your product",
        TypeProductNamePlaceholder: "Type a product name...",
        SearchForYourProduct: "Search for your product",
        SearchForYourProductHint: `Try a brand or product name, e.g. "Kirkland Minoxidil" or "Rogaine foam"`,
        ImagesSelected: "images selected",
        AddSelected: "Add Selected"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Define a new custom field",
        AttributeName: "Attribute Name",
        DataType: "Data Type",
        Noattributesfound: "No attributes found",
        ManageAttributes: "Manage Attributes",
        Editordeleteexistingattributes: "Edit or delete existing attributes",
        UpdateAttribute: "Update Attribute",
        Saving: "Saving...",
    },
    NewExpenses: {
        Noexpensesyet: 'No expenses yet',
        Addyourfirstexpensetostarttrackingyourspending: "Add your first expense to start tracking your spending.",
        TOTALEXPENSES: "TOTAL EXPENSES",
        ENTRIES: "ENTRIES",
        BYCATEGORY: "BY CATEGORY",
        Nocategoriestodisplay: "No categories to display",
        DateanfTime: "Date & Time"
    },
    PurchaseSales: {
        CancelOrder: "Cancel Order",
        ReopenOrder: "Reopen Order",
        Reopen: "Reopen",
        ConfirmCancelOrder: "Are you sure you want to cancel this order?",
        ConfirmReopenOrder: "Are you sure you want to reopen this order?",
        OrderCancelledSuccessfully: "Order cancelled successfully.",
        OrderReopenedSuccessfully: "Order reopened successfully.",
        CancelledBy: "Cancelled By",
        ConvertPriceBasedOnUnitConversion: "Convert Price Based on Unit Conversion",
        AccessDenied: "Access Denied",
        YouDonthaeP: "You don't have permission to view this page. If you believe this is a mistake, please contact your administrator.",
        purchase: "Purchase",
        sales: "Sales",
        Areyousureyouwantto: "Are you sure you want to",
        Thisactionwillupdateitsstatus: "This action will update its status.",
        viewAvailabilty: 'View Availability',
        ReasonOPtional: "Reason (Optional)",
        Enterareasonfor: "Enter a reason for",
        optionalDot: "(optional)...",
        Reject: "Reject",
        ConfirmOrder: "Confirm Order",
        RejectOrder: "Reject Order",
        Previous: "Previous",
        First: "First",
        Order: "Order",
        Items: "Items",
        Memo: "Memo",
        SelectDateRange: "Select Date Range",
        List: "List",
        Board: "Board",
        View: "View",
        OrderType: "Order Type",
        SelectOrderType: "Select Order Type",
        CreateSalesOrder: "Create Sales Order",
        CreatePurchaseOrder: "Create Purchase Order",
        successfully: "successfully",
        ManageAttachments: "Manage Attachments",
        MarkPaymentAsPending: "Mark Payment as Pending",
        PendingReceivableDesc: "Amount recorded as receivable. Record the payment when received.",
        PendingPayableDesc: "Amount recorded as payable. Record the payment when paid.",
        SelectCustomerFirst: "Select customer first",
        SelectSupplierFirst: "Select supplier first",
        SelectItemsFirst: "Please select at least one item first",
        PaymentMarkedPendingDesc: "Payment is marked as pending. Uncheck 'Mark payment as pending' to record payment now.",
        SelectCustomerAndItemFirst: "Please select customer and at least one item first",
        SelectSupplierAndItemFirst: "Please select supplier and at least one item first",
        SelectCustomerProductFirst: "Select customer & product first",
        SelectSupplierProductFirst: "Select supplier & product first",
        Receivables: "Receivables",
        Payables: "Payables",
        Stockoutitemsimmediatelyaftersaving: "Stock out items immediately after saving.",
        Stockinitemsimmediatelyaftersavingthisorder: "Stock in items immediately after saving this order.",
        ViewAttachments: "View Attachments",
        MemoAttachments: "Memo & Attachments",
        ReceivedDate: "Received Date",
        ShippedDate: "Shipped Date",
        OrderDate: "Order Date",
        OrderDetails: "Order Details",
        Subtotal: "Subtotal",
        OrderSummary: "Order Summary",
        AddItem: "Add Item",
        NewSalesOrder: "New Sales Order",
        NewPurchaseOrder: "New Purchase Order",
        Createandmanageyour: " Create and manage your",
        orders: "orders",
        Removeitem: "Remove item",
        UnitPrice: "Unit Price",
        PurchaseOrder: "Purchase Order",
        SalesOrder: "Sales Order",
        PurchaseInvoice: "Purchase Invoice",
        SalesInvoice: "Sales Invoice",
        PurchaseOrdernotfound: "Purchase Order not found",
        Approve: "Approve",
        MarkasShipped: "Mark as Shipped",
        MarkasReceived: "Mark as Received",
        Marking: "Marking...",
        PartiallyShip: "Partially Ship",
        PartiallyReceive: "Partially Receive",
        Deleting: "Deleting...",
        Transaction: "Transaction",
        Details: "Details",
        Item: "Item",
        Received: "Received",
        Shipped: "Shipped",
        Ordered: "Ordered",
        units: "units",
        Overalldiscount: "Overall discount",
        Transactions: "Transactions",
        Notransactionsfound: "No transactions found",
        OrderedQty: "Ordered Qty",
        Totalqty: "Total qty",
        StockingOut: "Stocking Out...",
        StockingIn: "Stocking In...",
        thiorderUpdateStuau: "this order? This action will update its status.",
        TransactionDetails: "Transaction Details",
        Fetchingtransactiondetails: "Fetching transaction details...",
        Nodetailsfoundforthistransaction: "No details found for this transaction.",
        TotalBreakDown: "Total BreakDown",
        ChangeAmount: "Change Amount",
        Attachments: "Attachments",
        PoNumber: "Po Number",
        SoNumber: "So Number",
        partner: "Partner",
        EditPurchase: "Edit Purchase",
        EditSales: "Edit Sales",
        PurchaseOrderDetails: "Purchase Order Details",
        SalesOrderDetails: "Sales Order Details",
        OrderTypePrepaid: "Prepaid",
        OrderTypeCOD: "Cash on Delivery",
        OrderTypePayLater: "Pay Later",
        OrderTypePartialPayment: "Partial Payment",
        OrderTypeSubscription: "Subscription",
        NotReceived: "Not Received",
        NotShipped: "Not Shipped",
        PartiallyReceived: "Partially Received",
        PartiallyShipped: "Partially Shipped",
        Cancelled: "Cancelled",
    },
    PriceReference: {
        HighPrice: "High Price",
        LowPrice: "Low Price",
        LastPrice: "Last Price",
        LastPurchasePrice: "Last Purchase Price",
        Nopricerecordsfound: "No price records found",
        BuyingPriceReference: "Buying Price Reference",
        SellingPriceReference: "Selling Price Reference",
        Viewstockinpricesfortheselectedvendorandproduct: "View stock-in prices for the selected vendor and product",
        Viewstockoutpricesfortheselectedcustomerandproduct: "View stock-out prices for the selected customer and product"
    },
    SubscriptionLocale: {
        premiumPlan: "Premium Plan",
        heading: "Make Business Decisions",
        headingHighlight: "Based on Data",
        subtitle: "Unlock the full power of your business analytics — no limits, no compromise.",

        choosePlan: "Choose your plan",

        monthly: "Monthly",
        annual: "Annual",
        oneTime: "One Time (Month)",
        perMonth: "per month",
        perYear: "per year",
        bestValue: "Best Value",

        continueWith: "Continue with",
        perMonthShort: "mo",
        perYearShort: "yr",

        troubleWithSubscription: "Trouble with subscription?",
        contactUs: "Contact Us",

        // Error messages
        paymentNotReady: "Payment not ready",
        checkoutError: "CHECKOUT ERROR",
        pricePreviewError: "PRICE PREVIEW ERROR",

        // Popup
        subNotAvailable: "Subscription not available",
        subNotAvailableDesc: "Web subscriptions are currently not available in your country. Please subscribe through our mobile app or contact us directly for help.",

    },
    SubscriptionLocale2: {
        GoPro: 'Go Pro',
        Makesmarterdecisionsbackedbyrealbusinessdata: "Make smarter decisions backed by real business data",
        ExploreProPlans: "Explore Pro Plans"
    },
    emptyWarehouseState: {
        tips: [
            "You can have multiple warehouses for different physical locations",
            "Each product tracks stock per warehouse independently",
            'Use "Transfer Warehouse" to move stock between locations'
        ],
        NoWarehousesConfigured: "No Warehouses Configured",
        desc: "Start by adding your warehouses (if you have more than one), then proceed to add products and record stock movements.",
        WarehouseSetupTips: " Warehouse Setup Tips",
        Noproductselected: "No product selected",
        Selectaproductfromthelefttoviewlowstockdetails: "Select a product from the left to view low stock details.",
        Chooseaproductfromthelist: "Choose a product from the list",
        SelectProduct: "Select Product",
        SetQuantity: "Set Quantity",
        Showing: "Showing",
        products: "products",
        Continue: "Continue",
        SaveSafetyStock: "Save Safety Stock",
        SafetyStockSaved: "Safety Stock Saved!",
        hasbeensetto: "has been set to",
        AddAnother: "Add Another",
        Chooseaproduct: "Choose a product",
        Step: "Step",
        of: "of",
        Setsafetyquantity: "Set safety quantity",
        Complete: "Complete",
        SafetyStockQuantity: "Safety Stock Quantity",
        Minimumunitsdropsbelowthisnumber: "Minimum units to always keep in stock. An alert fires when stock drops below this number.",
        NewSafetyStock: "New Safety Stock",
        SafetyNow: "Safety Now",
        SettingTo: "Setting To",
        Change: "Change",
        sell: "sell",
        cost: "cost",
        BulUD: "Bulk Upload/Delete"
    },
    SimplyLoginUI: {
        sslEncryption: "256-bit SSL Encryption",
        dataPrivate: "Your data is 100% private",
        worksOnDevices: "Works on Android & iPhone",
        realTimeSync: "Real-time sync across all devices",
        cloudBackup: "Automatic cloud backup",
        availableOn: "Available on Web, Android & iOS",
        tagline: "Your inventory,",
        taglineEm: "beautifully simple.",
        subtitle: "Sign in to manage stock, track sales, and keep your business moving — all in one place.",
        feature1Title: "Real-time stock tracking",
        feature1Desc: "Know exactly what's in each warehouse, always up to date.",
        feature2Title: "Sales & purchase orders",
        feature2Desc: "Create invoices, manage vendors, and track every transaction.",
        feature3Title: "Smart reports",
        feature3Desc: "Finance, stock, and daily movement reports at a glance.",
        feature4Title: "Real-time sync across all devices",
        feature4Desc: "Changes on phone instantly appear on web — and vice versa.",
        rating1: "Rated",
        rating2: "4.9/5",
        rating3: "by 10,000 wholesale businesses",
        brandName: "Simply",
        greeting: "Hello Again! 👋",
        noPasswordNeeded: "Sign in to access your inventory — Android, iPhone & web, all in sync.",
        badge1: "Stock Management",
        badge2: "Sales Tracking",
        badge3: "Reports",
        trustEncryptedTitle: "Encrypted",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "Private",
        trustPrivateSub: "Your data only",
        trustBackedTitle: "Backed up",
        trustBackedSub: "Auto daily",
        availableOnLabel: "AVAILABLE ON",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "All devices sync instantly in real-time",
        securityNote: "100% secure.",
        securityDesc: "Bank-grade encryption protects all your data. We only read your name and email — nothing else, ever.",
        signingIn: "Signing you in…",
        termsPrefix: "By signing in you agree to Simply's",
        privacyPolicy: "Privacy Policy",
        and: "and",
        termsOfService: "Terms of Service",
        google: "Login with Google",

    },
    BatchLocal: {
        BatchName: "Batch Name",
        EnterBatchName: "Enter batch name",
        EnterNotes: "Enter notes",
        ExpiredDate: " Expired Date",
        Selectexpireddate: "Select expired date",
        BatchStatus: "Batch Status",
        CreatedDate: "Created Date",
        Areyousureyouwanttodeletethisbatch: "Are you sure you want to delete this batch?",
        Youhavencreatedanybatchforthisproduct: "You haven't created any batch for this product.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Create your first batch to start tracking stock by lot & expiry.",
        Nobatchesyet: "No batches yet",
        Whatisbatchmanagement: "What is batch management?",
        Howithelpsyourbusiness: "How it helps your business",
        Trackbylotnumber: "Track by lot number",
        Trackbylotnumberdesc: "Group stock by manufacturer batch so you always know which lot a unit came from.",
        Expirydatecontrol: "Expiry date control",
        Expirydatecontroldesc: "Get alerts before stock expires. Sell older batches first and reduce waste automatically.",
        Fulltraceability: "Full traceability",
        Fulltraceabilitydesc: "See exactly which batch was used in every transaction — great for audits and recalls.",
        Supplierwisestock: "Supplier-wise stock",
        Supplierwisestockdesc: "Separate stock from different suppliers even for the same product. Compare quality batch by batch.",
        Createyourfirstbatchbutton: "Create your first batch",
        Nomatchesfound: "No matches found",
        NomatchesfounddescBefore: "We couldn't find any batches matching ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Clear Search",
        Nohistoryfoundthisbatch: "No history found for this batch",
        ComprehensiveDetails: "Comprehensive Details",
        History: "History",
        InBatch: "In Batch",
        Noproductfoundinthisbatch: "No product found in this batch",
        SelectBatch: "Select Batch",
        available: "available",
        Searchbatches: "Search batches...",
        Expires: "Expires",
        Nobatchesfound: "No batches found",
        ManageBatches: "Manage Batches",
        Batchmanagement: "Batch management",
        Trackstockexpiry: "Track stock by batch & expiry",
        Turnoffbatchmanagement: "Turn off batch management?",
        Yourgsafe: "Your existing batch data stays safe.",
        Reenableanytimefrom: "Re-enable anytime from",
        Otherstab: "Others tab",
        AddBatch: "Add Batch",
        Total: "Total",
        AssignProduct: "Assign Product",
        FurnishedProduct: "Furnished Product",
        FurnishedProductHelpText: "This furnished product will be used in the manufacturing process.",
        EditProductAssignment: "Edit Product Assignment",
        AssignProducttoBatch: "Assign Product to Batch",
        Updateproductconfiguration: "Update product configuration",
        Step1of2: "Step 1 of 2",
        Step2of2: "Step 2 of 2",
        Selectvariantwarehouse: "Select variant & warehouse",
        SelectedProduct: "Selected Product",
        AssignQuantity: "Assign Quantity",
        BatchInfo: "Batch Info",
        Wecouldnthisproductidentifier: "We couldn't find any batches associated with this product identifier.",
        NoActiveBatches: "No Active Batches",
        Endofresults: "End of results",
        Expiry: "Expiry",
        BatchManagementDescription: "Track stock by batch number and expiry date. Ensures correct LIFO / FEFO order on every stock-out — no manual picking needed.",
        Expiryalerts: "Expiry alerts",
        Autonotifications: "Auto-notifications",
        LIFOsorting: "LIFO / FEFO sorting",
        Smartstockflow: "Smart stock flow",
        Perout: "Per-batch stock-out",
        Precisiontracking: "Precision tracking",
        NeedsReview: "Needs Review",
        Pending: "Pending",
        Rejected: "Rejected",
        Approved: "Approved",
        WaitingForApproval: "Waiting for approval",
        WaitingForApprovalDesc: "Your owner will review and approve this batch shortly.",
        BatchRejected: "Batch rejected",
        BatchRejectedDesc: "Your owner rejected this batch.",
        Reason: "Reason",
        Approve: "Approve",
        Reject: "Reject",
        ConfirmApproveTitle: "Approve Batch",
        ConfirmRejectTitle: "Reject Batch",
        ConfirmApprovalAction: "Are you sure you want to {action} this batch? This action will update its status.",
        ReasonOptional: "Reason (Optional)",
        EnterReasonPlaceholder: "Enter a reason for {action} (optional)",
        Processing: "Processing...",
        BatchActivatedSuccess: "Batch activated successfully",
        BatchDeactivatedSuccess: "Batch deactivated successfully",
        BatchDeletedSuccess: "Batch deleted successfully",
        BatchApprovedSuccess: "Batch approved successfully",
        BatchRejectedSuccess: "Batch rejected successfully",
        SearchByBatchName: "Search by batch name...",
        YesTurnOff: "Yes, turn off",
        KeepItOn: "Keep it on"
    },
    OverDas: {
        movestockbetweenlocations: "Move stock",
        no_activity_yet: "No activity yet",
        no_activity_sub: "Sales, purchases, stock movements and returns will appear here in real time.",
        make_first_sale: "Make First Sale",
        add_stock: "Add Stock",
        all_stock_healthy: "All stock levels are healthy",
        all_stock_healthy_sub: "No items are running low. Set minimum thresholds on products to get alerts here.",
        set_stock_thresholds: "Set Stock Thresholds",
        no_warehouses_setup: "No warehouses set up",
        no_warehouses_setup_sub: "Add a warehouse to start tracking where your stock is stored and manage locations.",
        add_first_warehouse: "Add First Warehouse",
        Customer: "Customers",
        PurchasevsSales: "Purchase vs Sales",
        Financialperformancechart: "Financial performance chart",
        QuickActions: "Quick Actions",
        Frequentlyused: "Frequently used",
        Addinventory: "Add inventory",
        Dispatchitems: "Dispatch items",
        Addorder: "Add order",
        Newitem: "New item",
        Inventoryaccess: "Inventory access",
        Itemsneedingreorder: "Items needing reorder",
        Latesttransactions: "Latest transactions",
        Operationalsummary: "Operational summary",
        ViewAll: "View All",
        Manage: "Manage",
        RecentActivity: "Recent Activity",
        LowStockAlerts: "Low Stock Alerts",
        Primary: "Primary",
        TotalWarehouses: "Total Warehouses"
    },
    CategoryNewL: {
        TotalCategories: "Total Categories",
        lastaddedcategory: "last added category",
        acrossalltypes: "across all types",
        MostRecent: "Most Recent",
        YesD: "Yes, Delete",
        AllAssociated: "All associated products may be affected",
    },
    SerialLocal: {
        Manufacturesettings: "Manufacture settings",
        Showbuyingprice: "Buying Price / Product Cost",
        Showadditionalcost: "Additional Cost",
        Costbreakdown: "Cost Breakdown",
        Unitcost: "Unit Cost",
        Rawmaterialstotal: "Raw Materials Total",
        Confirmentry: "Confirm entry",
        SaveSerials: "Save Serials",
        SerialNumber: "Serial Number",
        selected: "selected",
        added: "added",
        Serialnumbers: "Serial numbers",
        ResetAll: "Reset All",
        Wecouldnfindthis: "We couldn't find any available serial numbers for this product.",
        Nounitsfound: "No units found",
        Searchingserialnumbers: "Searching serial numbers...",
        Scanorenterstock: "Scan or enter serials for new stock",
        Whataserialnumber: "What is a serial number?",
        Auniqueidentifieryourinventorylifecycle: "A unique identifier per unit — lets you track each individual item through your inventory lifecycle.",
        Trackedstockout: "Tracked stock out",
        Chooseexactlyselected: "Choose exactly which serial numbers are leaving. Only serials stocked in for this product are shown — quantity locks once you've selected ",
        SelectSerialstoout: " - Select Serials to out",
        Thisinvoicegeneratedusingwwwsimplstockco: "This invoice is generated using www.simplstock.co",
        AuthorizedSignature: "Authorized Signature",
        Invoicesettings: "Invoice settings",
        ShowOrHideFields: "Show or hide fields",
        ShowOrHideFieldsDesc: "Tap any item below to include or remove it from the printed invoice. Changes apply instantly.",
        Draw: "Draw",
        Taptoselectordeselectitems: "Tap to select or deselect items",
        Thissignaturewillbeadded: "This signature will be added to the bottom of your printed invoice.",
        SignatureOptions: "Signature Options",
        Upload: "Upload",
        DrawSignature: "Draw Signature",
        UploadSignature: "Upload Signature",
        Clear: "Clear",
        ShowStaffName: "Staff Name",
        ShowSKU: "SKU",
        ShowBusinessName: "Business Name",
        ShowProductName: "Product Name",
        ShowBusinessPhoneNumber: "Phone Number",
        ShowBusinessEmail: "Email",
        ShowBusinessAddress: "Address",
        ShowProductImage: "Product Image",
        ShowPaymentDetails: "Payment Details",
        ShowCategory: "Category",
        ShowVariant: "Variant",
        ShowWarehouse: "Warehouse",
        ShowAttributes: "Attributes",
        ShowQuantity: "Quantity",
        ShowDiscount: "Discount",
        ShowTax: "Tax",
        ShowPrice: "Price",
        ShowTotalPrice: "Product Total Price",
        ShowExpenses: "Expenses",
        ShowSignature: "Signature",
        ShowNote: "Note",
        showAttachment: "Attachment",
        ShowSerialNumber: "Serial Number",
        Invoicesettingsapplied: "Invoice settings applied. Check invoice for changes.",
        EnterSerialNumber: "Enter Serial Number",

    },
    FewLocal: {
        SelectBin: "Select Bin",
        Live: "Live",
        Monitorinventorystocklevels: "Monitor inventory, movement & stock levels",
        StockControlCentre: "Stock Control Centre",
        Nochartdataavailable: "No chart data available",
        Disabled: "Disabled",
        Enabled: "Enabled"
    },
    Bin: {
        Bin: "Bin",
        Add: "Add",
        NoBinsAddedYet: "No bins added yet",
        BinLocationsHelp: "Bin locations help you track stock by exact position inside this warehouse — no more searching.",
        NameThemByPosition: "Name them by position:",
        AddBinLocation: "Add Bin Location",
        BinLocations: "bin locations",
        BinNameRequired: "Bin name is required",
        EditBin: "Edit Bin",
        AddBin: "Add Bin",
        EnterBinName: "Bin Name",
        EnterBinNamePlaceholder: "Enter bin name",
        BinStatus: "Bin Status",
        BinNotes: "Notes",
        EnterBinNotesPlaceholder: "Add some notes...",
        ViewInventory: " View Inventory",
        Inventory: "Inventory",
        TrymatchingadifferentSKUname: "Try matching a different SKU or name.",
        Thisbinlocationcurrentlyempty: "This bin location is currently empty.",
        Loadingbins: "Loading bins...",
        bins: "Bins",
        ManageBin: "Manage Bin",
        Print: "Print",
        SBin: "Src Bin",
        DBin: "Dest Bin"

    },
    WarehouseExcel: {
        // Page Title & Description
        title: "Upload Warehouses & Bin Locations",
        description: "Follow the steps below to bulk create warehouses along with their bin locations using an Excel file.",

        // Steps
        bulkUploadGuide: "Bulk Upload Guide",
        step1: "Step 1",
        downloadTemplate: "Download the Excel template",
        downloadTemplateDesc: "Get the official template with all required column headers pre-configured. Do not rename or remove any columns.",
        downloadTemplateBtn: "Download Template",

        step2: "Step 2",
        fillExcelFile: "Fill in the Excel file",
        fillExcelDesc: "Each row represents one warehouse. Fill all columns — for bin locations, enter all bin names comma-separated in the <code>Bin Names</code> column.",

        step3: "Step 3",
        thingsToKeepInMind: "Things to keep in mind",
        rulesDesc: "Before uploading, make sure your file follows these rules to avoid errors.",

        step4: "Step 4",
        uploadYourFile: "Upload your file",
        uploadDesc: "Once filled, upload the file below. The system will create all warehouses and bin locations automatically.",

        // Rules
        rules: [
            "One row per warehouse only",
            "Bin names comma-separated in one cell",
            "Do not rename column headers",
            "Duplicate bin names per warehouse are skipped",
            "Phone number with country code",
            "Only .xlsx or .xls files accepted"
        ],

        // Upload Box
        dropFileHere: "Drop your Excel file here",
        supports: "Supports .xlsx and .xls — max 10 MB",
        chooseFileUpload: "Choose File & Upload",
        parsing: "Parsing file...",

        // Errors
        invalidFileType: "Invalid file type. Please upload an Excel file.",
        noData: "No data found in Excel",
        failedToRead: "Failed to read Excel file",
        unableToRead: "Unable to read the file.",

        // Review Screen
        reviewTitle: "Review Warehouse Data",
        reviewSubtitle: "Final check before importing into your business.",
        changeFile: "Change File",
        rowsFound: "rows found in file",
        cancel: "Cancel",
        finalizeImport: "Finalize & Import",
        importing: "Importing...",

        // Toast Messages
        success: "Success",
        allWarehouseUploadedSuccess: "All warehouses uploaded successfully",
        failed: "Failed",
        bulkUploadFailed: "Bulk upload failed",
        error: "Error",

        // Bin Names Column Note
        binNamesNote: "In the <strong>Bin Names</strong> column, enter all bin locations for a warehouse in a single cell, separated by commas — e.g. A1, A2, B1, RACK-01. Do not create separate rows per bin.",

        // Table Headers
        headers: {
            warehouseName: "Warehouse Name",
            email: "Email",
            phoneNumber: "Phone Number",
            location: "Location",
            binNames: "Bin Names"
        }
    },
    CustomerExcel: {
        title: "Upload Customers",
        description: "Follow the steps below to bulk create customers using an Excel file.",
        bulkUploadGuide: "Bulk Upload Guide",
        step1: "Step 1",
        downloadTemplate: "Download the Excel template",
        downloadTemplateDesc: "Get the official template with all required column headers pre-configured.",
        downloadTemplateBtn: "Download Template",
        step2: "Step 2",
        fillExcelFile: "Fill in the Excel file",
        fillExcelDesc: "Each row represents one customer. Fill all columns as required.",
        step3: "Step 3",
        thingsToKeepInMind: "Things to keep in mind",
        rulesDesc: "Before uploading, make sure your file follows these rules to avoid errors.",
        step4: "Step 4",
        uploadYourFile: "Upload your file",
        uploadDesc: "Once filled, upload the file below. The system will create all customers automatically.",
        rules: [
            "One row per customer only",
            "Do not rename column headers",
            "Contact number with country code",
            "Only .xlsx or .xls files accepted"
        ],
        dropFileHere: "Drop your Excel file here",
        supports: "Supports .xlsx and .xls — max 10 MB",
        chooseFileUpload: "Choose File & Upload",
        parsing: "Parsing file...",
        invalidFileType: "Invalid file type. Please upload an Excel file.",
        noData: "No data found in Excel",
        failedToRead: "Failed to read Excel file",
        unableToRead: "Unable to read the file.",
        reviewTitle: "Review Customer Data",
        reviewSubtitle: "Final check before importing into your business.",
        changeFile: "Change File",
        rowsFound: "rows found in file",
        cancel: "Cancel",
        finalizeImport: "Finalize & Import",
        importing: "Importing...",
        success: "Success",
        allCustomerUploadedSuccess: "All customers uploaded successfully",
        failed: "Failed",
        bulkUploadFailed: "Bulk upload failed",
        error: "Error",
        headers: {
            customerName: "Customer Name",
            phoneNumber: "Contact",
            address: "Address",
            note: "Note"
        }
    },
    SupplierExcel: {
        title: "Upload Vendors",
        description: "Follow the steps below to bulk create vendors using an Excel file.",
        bulkUploadGuide: "Bulk Upload Guide",
        step1: "Step 1",
        downloadTemplate: "Download the Excel template",
        downloadTemplateDesc: "Get the official template with all required column headers pre-configured.",
        downloadTemplateBtn: "Download Template",
        step2: "Step 2",
        fillExcelFile: "Fill in the Excel file",
        fillExcelDesc: "Each row represents one vendor. Fill all columns as required.",
        step3: "Step 3",
        thingsToKeepInMind: "Things to keep in mind",
        rulesDesc: "Before uploading, make sure your file follows these rules to avoid errors.",
        step4: "Step 4",
        uploadYourFile: "Upload your file",
        uploadDesc: "Once filled, upload the file below. The system will create all vendors automatically.",
        rules: [
            "One row per vendor only",
            "Do not rename column headers",
            "Contact number with country code",
            "Only .xlsx or .xls files accepted"
        ],
        dropFileHere: "Drop your Excel file here",
        supports: "Supports .xlsx and .xls — max 10 MB",
        chooseFileUpload: "Choose File & Upload",
        parsing: "Parsing file...",
        invalidFileType: "Invalid file type. Please upload an Excel file.",
        noData: "No data found in Excel",
        failedToRead: "Failed to read Excel file",
        unableToRead: "Unable to read the file.",
        reviewTitle: "Review Vendor Data",
        reviewSubtitle: "Final check before importing into your business.",
        changeFile: "Change File",
        rowsFound: "rows found in file",
        cancel: "Cancel",
        finalizeImport: "Finalize & Import",
        importing: "Importing...",
        success: "Success",
        allSupplierUploadedSuccess: "All vendors uploaded successfully",
        failed: "Failed",
        bulkUploadFailed: "Bulk upload failed",
        error: "Error",
        headers: {
            supplierName: "Vendor Name",
            phoneNumber: "Contact",
            bankName: "Bank Name",
            accountHolderName: "Account Holder Name",
            accountNumber: "Account Number",
            note: "Note"
        }
    },
    VariantTemplate: {
        VariantTemplates: "Variant Templates",
        Managereusablevariantpatterns: "Manage reusable variant patterns",
        BinTransferHistory: "Bin Transfer History",
        Trackmovementsacrossbins: "Track movements across bins",
        SerialNumberHistory: "Serial Number History",
        Trackproductserialnumberactivity: "Track product serial number activity",
        Period: "Period",
        Nohistoryfound: "No history found",
        Searchserialnumbers: "Search serial numbers...",
        SerialNumbersHistory: "Serial Numbers History",
        Serialnumberhistoryglance: "Serial number history at a glance.",
        Noserialnumbersfound: "No serial numbers found",
        Noactivityhistoryfound: "No activity history found",
        Statussetto: "Status set to",
        Timeline: "Timeline",
        Managereusableproductvariantpatterns: " Manage reusable product variant patterns.",
        DeleteTemplate: "Delete Template",
        Areyousureyouwanttemplate: "Are you sure you want to delete this template?",
        CreateNewTemplate: "Create New Template",
        CreateTemplate: "Create Template",
        EditTemplate: "Edit Template",
        UnlimitedTemplates: "Unlimited templates",
        CreateAsManyTemplates: "Create as many templates as you need — Clothing, Footwear, Electronics and more.",
        PickWhileAddingProduct: "Pick while adding a product",
        OpenTemplateLibrary: "Open your template library and select variant names in seconds.",
        MixFromMultipleTemplates: "Mix from multiple templates",
        SelectFromMultipleTemplates: "Select variant names from more than one template for a single product — fully flexible.",
        EditAnytime: "Edit anytime",
        RenameTemplatesAnytime: "Rename templates, add or remove variant names whenever your catalog changes.",
        StayConsistent: "Stay consistent",
        SameVariantNamesAcrossAll: "Same variant names across all products. No typos, no duplicates, no guesswork.",
        BuildOnceUseEverywhere: "Build once, Use everywhere",
        StopReEnteringVariantNames: "Stop re-entering the same variant names for every product. Create a template, assign variant names to it, and reuse it instantly.",
        Updateexistingvariantcombinations: "Update existing variant combinations",
        Definenewvariantcombinations: "Define new variant combinations",
        TemplateName: "Template Name",
        AddVariantOptions: "Add Variant Options",
        SmallMedium: "e.g. Small, Medium...",
        VariantsList: "Variants List",
        Nooptionsaddedyet: "No options added yet",
        SaveTemplate: "Save Template",
        egSizesColorsetc: "e.g. T-Shirt Sizes, Colors, etc.",
        Pleaseentertemplatename: "Please enter a template name",
        Pleaseaddatleastonevariantoption: "Please add at least one variant option",
        Templateupdatedsuccessfully: "Template updated successfully",
        Templatecreatedsuccessfully: "Template created successfully",
        Failedtosavetemplate: "Failed to save template",
        Transfer: "Transfer",
        Editassignment: "Edit assignment",
        Updateproductdetailsinbin: "Update product details in bin",
        Editinginbin: "Editing in bin",
        ConfirmUpdate: "Confirm Update",
        ConfirmAssign: "Confirm Assign",
        Assignanotherproduct: "Assign another product",
        TransferBin: "Transfer Bin",
        SourceBin: "Source Bin",
        DestinationBin: "Destination Bin",
        SelectSourceBin: "Select Source Bin",
        SelectDestinationBin: "Select Destination Bin",
        Unit: "Unit",
        ManageVariant: "Manage Variant",
        CreateSKUvariationsyourproduct: "Create SKU variations for your product",
        Assigningvariationsto: "Assigning variations to",
        Novariantsaddedyet: "No variants added yet",
        AddedVariants: "Added Variants",
        AddVariantsfromTemplate: "Add Variants from Template",
        Pickatemplateandselectvariantnames: "Pick a template and select variant names",
        ChooseaTemplate: "Choose a Template",
        Selectvariantnamestoadd: "Select variant names to add",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Select a template to pick variant names from. You can add from multiple.",
        Loadingtemplates: "Loading templates...",
        Backtotemplates: "Back to templates",
        Selectallindividualadd: "Select all or individual variant names to add.",
        VariantNames: "Variant Names",
        MediaDescription: "Media & Description",
        Addattachmentsandproductnotes: "Add attachments and product notes",
        ProductMedia: "Product Media"
    },

    AddProductGuide: {
        title: "Add initial quantity after saving",
        description:
            "Products don't carry a quantity field here. Once saved, use Stock In to log your opening stock — with full control over location and tracking.",

        steps: {
            quantity: {
                title: "Quantity",
                sub: "Set opening stock count",
            },
            binLocation: {
                title: "Bin location",
                sub: "Aisle, rack, shelf — e.g. A-01-03",
            },
            serialNumbers: {
                title: "Serial numbers",
                sub: "Track each unit individually",
            },
            warehouse: {
                title: "Warehouse",
                sub: "Which location it's stored in",
            },
            batchExpiry: {
                title: "Batch / expiry",
                sub: "Group stock by batch number",
            },
        },

        actions: {
            close: "Close",
        },
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "No Transfer Orders Found",
        Itemshistory: "Items you transfer between warehouses will appear here for tracking and history.",
        CreateTransfer: "Create Transfer"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Tap on product to Manufacture",
        Selectproductfrombelow: "Select a product from the list below",
        SetupANewProduct: 'Setup new product',
        DefineAProductAdditsrawmaterial: "Define a product & add its raw materials",
        ManufacturingSetup: "Manufacturing Setup",
        Pickproducttodefineitsproductiondetails: "Pick a product to define its production details",
        ConfigureManufacturing: "Configure Manufacturing",
        SelectRawMaterial: "Select Raw Material",
        NoRawMaterials: "No Raw Materials",
        Definecomponentsneededtoproduct: "Define components needed to manufacture this product.",
        NoAdditionalCosts: "No Additional Costs",
        Addlaboroverheadlogisticalcharges: "Add labor, overhead, or logistical charges.",
        AddAdditionalCost: "Add Additional Cost",
        AddCost: "Add Cost",
        TotalPrice: "Total Price",
        SelectCharges: "Select Charges",
        EnterEstimatedCost: "Enter estimated cost",
        QtyRequried: "Qty Required",
        Manufacturing: "Manufacturing",
        Outputfinishedgoodsdestination: "Output — finished goods destination",
        Manufacturingquantity: "Manufacturing quantity",
        Storefinishedgoodsat: "Store finished goods at",
        Rawmaterials: "Raw materials",
        StockSelection: "Stock Selection",
        AdditionalCosts: "Additional Costs",
        Quantityconsume: "Quantity to consume",
        Totalmanufacturingcost: "Total manufacturing cost",
        Sumofrawmaterialcosts: "Sum of all raw material costs",
        CustomManufacturingCharge: "Custom Manufacturing Charge",
        Addextralikelaboroverheadrepairs: "Add extra costs like labor, overhead, or repairs.",
        CalculatedTotal: "Calculated Total",
        AddRawMaterial: "Add Raw Material",
        ConfigureRawMaterial: "Configure Raw Material",
        Thisoutputunit: "This is the base quantity required per output unit.",
        ChangeProduct: "Change Product",
        AddtoList: " Add to List",
        Manufacture: "Manufacture",
        EditDeleteHistory: "Edit/Delete History",
        ManageOrder: "Manage Order",
        ManageBatch: "Manage Batch",
        Paymentnotavailablehere: "Payment not available here",
        Thisrecordisanorderorderitself: "This record is from an order. Payment can only be recorded from the order itself.",
        Torecorpaymenttheorderthethere: "To record a payment, go to the linked order and use the <b>Record Payment</b> option there.",
        GotoOrder: "Go to order"
    },
    ReplaceReturnLocal: {
        BuyingPrice: "Buying Price",
        SellingPrice: "Selling Price",
        ReplacedWith: "Replaced With",
        Noreplacementhistoryfound: "No replacement history found",
        Noreturnhistoryfound: "No return history found",
        Productbeingreturned: "Product being returned",
        Required: "Required",
        Selectreturnedproduct: "Select returned product",
        Searchnamescanbarcode: "Search by name, SKU or scan barcode",
        Browse: "Browse",
        Stockhandling: "Stock-in handling",
        Stockinreturnedproduct: "Stock in returned product",
        Ontoinventory: "On — returned item will be added back to inventory",
        Offreturnedonly: "Off — item will be logged as returned only",
        Usedrestock: "Used to calculate profit adjustment on restock",
        Willaddedbackconfirmation: "Will be added back to inventory on confirmation",
        Returnreason: "Return reason",
        Optional: "Optional",
        SelectReason: "Select Reason",
        Additionalnotes: "Additional notes",
        Describeofcustomerexplanation: "Describe the condition of the returned item, any visible damage, customer's explanation...",
        Requiredmustfilledcontinue: "Required fields must be filled to continue",
        Reviewdetailsbeforeconfirming: "Review the details before confirming",
        Replacementproductwilldeductedinventoryconfirmation: "Replacement product will be deducted from your inventory on confirmation.",
        Choosereplacementproduct: "Choose replacement product",
        Willdeductedfrominventoryconfirm: "Will be deducted from inventory on confirm",
        Thesewillattachedothereturnrecord: "These images will be attached to the return record",
        Replacementitem: "Replacement item",
        Addanotherproduct: "Add another product",
        Replacementproductwillbe: "Replacement product will be",
        deducted: "deducted",
        fromyourinventoryconfirmation: "from your inventory on confirmation.",
        productadjustedusingprice: "Returned product will be restocked and profit adjusted using the original sale price.",
        Willloggedreturnedonlynotrestocked: "Will be logged as returned only — not restocked",
        Returnonly: "Return only",
        Imagesofreturnedproduct: "Images of returned product",
        Returnedproductwill: "Returned product will",
        not: "not",
        berestockedloggedreturnedonly: "be restocked — logged as returned only.",
        AddImage: "Add Image",
        STOCKIN: "STOCK-IN",
        LOGONLY: "LOG ONLY",
        ContinuetoReview: "Continue to Review →",
        Confirmreplacement: "Confirm replacement",
        Confirmreturn: "Confirm return",
        ConfirmEdit: "Confirm edit",
        Filldetailsbelowproceed: "Fill in the details below to proceed",
        Review: "Review",
        editdetails: "Edit details",
        Configurereturndetails: "Configure return details",
        Configurereplacementdetails: "Configure replacement details",
        SelectSource: "Select Source",
        Returning: "Returning",
        Replacement: "Replacement",
        WalkCustomer: "Walk-in Customer",
        RETURNEDPRODUCT: "RETURNED PRODUCT",
        REPLACEMENTPRODUCT: "REPLACEMENT PRODUCT",
        STOCKOUT: "STOCK-OUT",
        Netinventoryimpact: "Net inventory impact",
        Replacementitemcost: "Replacement item cost",
        Returneditemrestockvalue: "Returned item restock value",
        PROFITINVENTORYSUMMARY: "PROFIT & INVENTORY SUMMARY",
        Inventoryaction: "Inventory action",
        Valuededucted: "Value deducted",
        Profitadjustment: "Profit adjustment",
        stockedout: " stocked out",
        restocked: " restocked",
        Noaction: "No action",
        Valuebeingreturned: "Value being returned",
        Willberestocked: "Will be restocked",
        Willbe: "Will be",
        logged: "logged",
        ON: "ON",
        OFF: "OFF",
        Linked: "Linked",
        Pleaseselectreturnedproduct: "Please select a returned product",
        Quantityrequired: "Quantity is required",
        Buyingpricerequired: "Buying price is required",
        Pleaseaddleastreplacementproduct: "Please add at least one replacement product",
        Pleaseconfigurereturnedproductdetails: "Please configure the returned product details",
        Pleaseselectcustomer: "Please select a customer",
        Returndateisrequired: "Return date is required",
        Pleasefillallrequiredfields: "Please fill all required fields",
        Wildeductedfrominventory: "Will be deducted from inventory",
        Currentprice: "Current price",
        Defectivedamaged: "Defective / damaged",
        Wrongitemreceived: "Wrong item received",
        Customerchangedmind: "Customer changed mind",
        Sizefitissue: "Size / fit issue",
        Notasdescribed: "Not as described",
        Other: "Other",
        Originalsaleprice: "Original sale price (profit adj.)",
        Addedbackinventory: "Added back to inventory",
        Notaddedinventory: "Not added to inventory",
        replacedwith: "replaced with",
        deductedfrominventory: "deducted from inventory",
        RETURNWITHSTOCKIN: "RETURN · WITH STOCK-IN",
        RETURNNOSTOCKIN: "RETURN · NO STOCK-IN",
        MULTIPLEREPLACEMENTS: "MULTIPLE REPLACEMENTS",
        SINGLEREPLACEMENT: "SINGLE REPLACEMENT",
        RETURNEDSTOCKIN: "RETURNED · STOCK IN",
        REPLACEMENTSTOCKOUT: "REPLACEMENT · STOCK OUT",
        Returnonlylogsthisentry: "Return only logs this entry —",
        nostockwillbeaddedorremoved: "no stock will be added or removed",
        frominventory: "from inventory.",
        Whentousethis: "When to use this:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Use Return at end of day to record items sent out for sales that came back damaged or unusable — items you want to track but cannot add back to inventory.",
        Youcanviewallpastreturnentriesin: "You can view all past return entries in",
        ReturnHistory: "Return History",
        underthe: "under the",
        Others: "Others",
        tab: "tab.",
        Negativestocktransactiondisabled: "Negative stock transactionsP are disabled."
    },
    NewRLocal: {
        Originalsaleprice: "Original sale price",
        Editinghistoryonlyinventorystaysunchanged: "Editing history only — inventory stays unchanged.",
        Changeshereupdatethisdetailsquantitiesaffected: "Changes here update this record's details (reason, date, notes) only. Your actual stock quantities, bin locations, and product data are not affected.",
        Needtofixinventorylevelsinstead: "Need to fix inventory levels instead?",
        AdjustStock: "Adjust Stock",
        Refund: "Refund",
        ImportantNote: "Important Note",
        Pleasereviewbeforecontinuing: "Please review before continuing",
        Onceshippedreceivedanyupdatesmadeorder: "Once an order is shipped or received, any updates made to the order will not reflect in the transaction history.",
        Thisundone: "This will permanently remove the order. This action cannot be undone.",
        Inventorywilladjustedautomatically: "Inventory will not be adjusted automatically",
        Deletingthisreversevedshippedyouwillneed: "Deleting this order does not reverse any stock changes. If items were already received/shipped, you will need to",
        reflectthecorrectstocklevels: "to reflect the correct stock levels.",
        manuallyadjustyourinventory: "manually adjust your inventory",
        Addremovestockforitemsthatwereshipped: "Add or remove stock for items that were shipped",
        Addremovestockforitemsthatwerereceived: "Add or remove stock for items that were received",
        Updatecostrecordspaymentwaalreadymade: "Update cost records if payment was already made",
        Reconcilerecordsandoutstandingpayments: "Reconcile records and outstanding payments"
    },
    ReceivablesLocal: {
        Receivables: "Receivables",
        Manageandtrackcustomerduebalances: "Manage and track customer due balances",
        Viewcustomerduebalancereport: "View customer due balance report",
        Viewsupplierduebalancereport: "View supplier due balance report",
        DueBalance: "Due Balance",
        Unpaid: "Unpaid",
        PartiallyPaid: "Partially Paid",
        Paid: "Paid",
        HighestBalance: "Highest Balance",
        LowestBalance: "Lowest Balance",
        Filldetailsrecordpayment: "Fill details to record payment",
        NewPaymentEntry: "New Payment Entry",
        EditPaymentEntry: "Edit Payment Entry",
        Nosuppliersfound: "No suppliers found",
        Nocustomersfound: "No customers found",
        LowtoHigh: 'Low to High',
        HightoLow: 'High to Low',
        AttachmentUploadedSc: "Attachment uploaded successfully",
        AttachmentUploadedF: "Attachment failed to upload",
        Pay: "Pay",
        NoBillsFound: "No Bills Found",
        Thiscustomerhasunpaidbills: "This customer has no unpaid bills.",
        TotalDue: "Total Due",
        BillsFound: "Bills Found",
        DeselectAll: "Deselect All",
        SelectAll: "Select All",
        ShowDetails: "Show Details"
    },
    AssetsNewLocal: {
        Total: "Total",
        Assigned: "Assigned",
        Remaining: "Remaining",
        Available: "Available",
        NoSerialNumbers: "No serial numbers",
        UpdateExistingAssetDetails: "Update existing asset details",
        RegisterNewBusinessAsset: "Register a new business asset",
        BasicInformation: "Basic Information",
        AssetDetails: "Asset Details",
        Quantity: "Quantity",
        SerialNumbers: "Serial Numbers",
        SerialNumberPlaceholder: "Serial number",
        AddSerialNumber: "Add Serial Number",
        SerialNumbersOptional: "Serial numbers are optional. You can add up to",
        AssetImages: "Asset Images",
        AdditionalNotes: "Additional Notes",
        AdditionalNotesPlaceholder: "Any additional details or maintenance history...",
        Updating: "Updating...",
        Adding: "Adding...",
        ITEquipmentPlaceholder: "e.g. IT Equipment",
        LoadingMoreActivities: "Loading more activities...",
        AssignedAssets: "Assigned Assets",
        Noassetsassignedstaffmember: "No assets assigned to this staff member.",
        Assignassetstaff: "Assign an asset to staff",
        Returnassetfromstaff: "Return this asset from staff",
        AssignmentDetails: "Assignment Details",
        Serial: "Serial",
        ViewAssets: "View All Assets",
        ViewByStaff: "View By Staff",
        AssignedHistory: "Asset History",
        Returned: "Returned",
        Returnedon: "Returned on",
        Assignedon: "Assigned on",
        ReturnedBy: "Returned By",
        AssignedTo: "Assigned To",
        NoHistoryRecords: "No History Records",
        Selectstaffmemberviewtheirassets: "Select a staff member to view their assets.",
        Deleted: "DELETED",
        searchPlaceholder: "Search asset by name or serial number..."
    },
    InventoryCountLocale: {
        InventoryCount: "Inventory Count",
        Viewinventorycountreport: "View inventory count report",
        ItemsCount: "Items Count",
        All: "All",
        InProgress: "In Progress",
        Submitted: "Submitted",
        awaitingreview: "Awaiting Review",
        EditInventoryCount: "Edit Inventory Count",
        NewInventoryCount: "New Inventory Count",
        Modifyinventorycountsheetdetails: "Modify inventory count sheet details",
        Startanewinventorycountsheet: "Start a new inventory count sheet",
        GeneralInformation: "General Information",
        Title: "Title",
        SaveChanges: "Save Changes",
        Selectproductsforthisinventorycountsheet: "Select products for this inventory count sheet",
        InventoryCountDetails: "Inventory Count Details",
        Inventorycountsheetdetails: "Inventory count sheet details",
        Viewingdetailsforcountsheet: "Viewing details for count sheet",
        Started: "Started",
        TaskSheets: "Task Sheets",
        Allitems: "All items",
        NotStarted: "Not Started",
        Completed: "Completed",
        Results: "Results",
        ViewResults: "View Results",
        DeleteInventoryCount: "Delete Inventory Count",
        Viewingtransactionandadjustments: "Viewing transaction logs and stock adjustments",
        Productsadjusted: "Products adjusted",
        Assignee: "Assignee",
        Tasksheetdetails: "Task sheet details",
        Draft: "Draft",
        VariantQuantities: "Variant Quantities",
        AssignedProducts: "Assigned Products",
        ReturnAsset: "Return Asset",
        EditTasksheet: "Edit Task sheet",
        NewTasksheet: "New Task sheet",
        Updatetasksheetdetails: "Update task sheet details",
        Starttasksheetforthisinventorycount: "Start a new task sheet for this inventory count",
        TaskSheetInformation: "Task Sheet Information",
        SheetTitle: "Sheet Title",
        Entersheettitle: "Enter sheet title",
        SubmissionResult: "Submission Result",
        ReviewChanges: "Review Changes",
        Viewingsubmissionresultsforthisinventorycount: "Viewing submission results for this inventory count",
        Reviewyourinventorycountbeforesubmitting: "Review your inventory count before submitting"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Failed to load counts",
        NoInventoryCounts: "No Inventory Counts",
        NoMatches: "No Matches",
        Therearenoinventorycountswiththestatus: "There are no inventory counts with the status",
        Noinventorycountsfoundyoursearchterm: "No inventory counts found matching your search term.",
        Thereareinventorycountsrecordedyetforthisbusiness: "There are no inventory counts recorded yet for this business."
    },
    StockinModalP: {
        StockInNow: "Stock In Now",
        Settheopeningquantityforthisproductrightnow: "Set the opening quantity for this product right now.",
        Addinitialstock: "Add initial stock?",
        dothislater: "I'll do this later",
        Productadded: "Product added!",
        isready: "is ready.",
        SeeHowItWorks: "See How It Works",
        NoSalesOrdersFound: "No Sales Orders Found",
        NoPurchaseOrdersFound: "No Purchase Orders Found",
        Startcreatingoutgoinginventoryrevenue: "Start creating sales orders to track your outgoing inventory and revenue.",
        Trackrestockssupplierplace: "Track your inventory restocks and supplier orders in one place.",
        CreateSalesOrder: "Create Sales Order",
        CreatePurchaseOrder: "Create Purchase Order",
    },
    dialy_report: "Daily Movement Report",
    Quotation: "Quote",
    Quote: "Quote",
    ShowStatus: "Status",
    Assignee: "Assignee",
    dayStart: "day start",

    ShowTotalAmount: "Total Amount",

    tutorial: {
        watchTitle: 'Watch step-by-step tutorials',
        watchDesc: 'Learn SimplyStock on our YouTube channel',
        modalTitle: 'Stay ahead with SimplyStock',
        modalDesc: 'Subscribe to get new tutorials the moment they drop',
        feature1Title: 'New feature walkthroughs',
        feature1Sub: 'Every new update explained with a short video — so you never miss what\'s new',
        feature2Title: 'Quick how-to videos',
        feature2Sub: 'Set up stock, invoices, staff access and more in under 5 minutes',
        feature3Title: 'Instant notifications',
        feature3Sub: 'Get notified the moment a new tutorial is live — learn at your own pace',
        feature4Title: '100% free, always',
        feature4Sub: 'All tutorials are free forever — no login or subscription needed',
        subscribeBtn: 'Subscribe to SimplyStock',
        maybeLater: 'Maybe later'
    }
    ,
    dailyCashReport: {
        title: "Daily Cash Report",
        subtitle: "Who paid what, on which date, and what's still owed — grouped from Sales Detail.",
        totalSales: "Total sales",
        "cashReceived": "Total Received",
        outstanding: "Outstanding",
        collectionRate: "Collection rate",
        grandTotalAllDates: "GRAND TOTAL (all dates)",
        totalLabel: "Total",
        loading: "Loading...",
        noData: "No data found for the selected date range.",
        loadingMore: "Loading more..."
    },
    dailyCashReportColumns: {
        date: "Date",
        customer: "Customer",
        productsSold: "Products Sold",
        products: "Products",
        salesAmount: "Sales Amount",
        sales: "Sales",
        "received": "Total Received",
        receivedShort: "Received",
        debited: "Debited to Ledger",
        due: "Due",
        paymentModes: "Payment Mode(s)",
        mode: "Mode"
    }
}

export default en
